(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9399,4196],{

/***/ 15019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgEcScores(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    fill: "#FFF",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 8h12v12H8z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 15.38c0-.935.848-1.694 1.895-1.694h1.263v5.647H9.895C8.848 19.333 8 18.575 8 17.64V15.38z",
    fill: "#FEAAFF"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19.965 14.06c.181-.7-.366-1.379-1.11-1.379l-3.402-.001.314-1.826c.153-.884-.332-1.755-1.177-2.119-.537-.23-1.141.15-1.141.718v.98c0 .378-.133.744-.377 1.04l-1.914 2.316v5.544h6.104c.788 0 1.475-.52 1.666-1.26l1.037-4.014z",
    fill: "#655AEC"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgEcScores);

/***/ }),

/***/ 87985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgViews(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    fill: "#FFF",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.937 13.898c.054.65.646 1.125 1.292 1.125h1.136v.715A2.26 2.26 0 0117.116 18H10.25A2.26 2.26 0 018 15.738V11.69a2.26 2.26 0 012.25-2.261h6.866a2.26 2.26 0 012.25 2.261v.867h-1.209c-.335 0-.64.132-.861.36a1.212 1.212 0 00-.36.98z",
    fill: "#655AEC"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20 14.41c0 .33-.263.6-.598.613h-1.173c-.646 0-1.238-.475-1.292-1.125a1.212 1.212 0 01.36-.98c.22-.229.526-.361.86-.361h1.245a.616.616 0 01.598.613v1.24zM10.692 12.534c-.245 0-.449-.227-.449-.5s.204-.5.449-.5h4.187c.245 0 .449.227.449.5s-.204.5-.449.5h-4.187z",
    fill: "#FEAAFF"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgViews);

/***/ }),

/***/ 50458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgBill(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    fill: "#FFF",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.458 16.263a2.333 2.333 0 102.915 3.641 2.333 2.333 0 00-2.915-3.64zm1.832 2.34l-.73.437a.44.44 0 01-.6-.146.437.437 0 01.152-.6l.519-.31v-.63a.432.432 0 01.431-.437.44.44 0 01.438.437v.875a.438.438 0 01-.21.373z",
    fill: "#FEAAFF"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.663 11.521h-.875V9.305c0-.158-.14-.234-.234-.234a.234.234 0 00-.087.018L9.84 10.833a.784.784 0 00-.508.74v.392a2.18 2.18 0 00-.875 1.75v-2.141c0-.694.426-1.313 1.074-1.558l4.631-1.75a1.111 1.111 0 011.5 1.038v2.217z",
    fill: "#655AEC",
    fillRule: "nonzero"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19.542 16.042a.291.291 0 01-.286.291h-.851c-.31 0-.59-.227-.613-.53a.582.582 0 01.578-.636h.88c.17.005.292.134.292.291v.584z",
    fill: "#FEAAFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18.958 14.554c.321 0 .584-.262.584-.583v-.257a2.198 2.198 0 00-2.194-2.193h-6.696c-.496 0-.951.163-1.319.443a2.18 2.18 0 00-.875 1.75v1.038c0 .222.234.362.444.292.326-.11.67-.169 1.015-.169a3.214 3.214 0 013.208 3.208c0 .42-.11.881-.286 1.29-.093.21.053.46.28.46h4.23a2.198 2.198 0 002.193-2.193v-.11a.585.585 0 00-.584-.584h-.507c-.56 0-1.097-.344-1.243-.887a1.174 1.174 0 01.315-1.155c.216-.221.514-.35.84-.35h.595zm-6.708-.117a.44.44 0 01-.438-.437.44.44 0 01.438-.438h2.917a.44.44 0 01.437.438.44.44 0 01-.437.438H12.25z",
    fill: "#655AEC"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgBill);

/***/ }),

/***/ 99506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgIcInfluencerLive(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.16 10.1V5.893l1.853-1.3c.907-.633 1.654-.246 1.654.867v5.08c0 1.113-.747 1.5-1.654.86l-1.853-1.3zM7.667 7.333a1 1 0 110-2 1 1 0 010 2z",
    stroke: "#A39CF4"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4.14 13.613c-2.107 0-2.807-1.4-2.807-2.806V5.193c0-2.106.7-2.806 2.807-2.806h4.213c2.107 0 2.807.7 2.807 2.806v5.614c0 2.106-.707 2.806-2.807 2.806H4.14z",
    stroke: "#655AEC"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgIcInfluencerLive);

/***/ }),

/***/ 44910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgIcInfluencerLiveGray(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    stroke: "#888ba6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.16 10.1V5.893l1.853-1.3c.907-.633 1.654-.246 1.654.867v5.08c0 1.113-.747 1.5-1.654.86l-1.853-1.3zM7.667 7.333a1 1 0 110-2 1 1 0 010 2z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4.14 13.613c-2.107 0-2.807-1.4-2.807-2.806V5.193c0-2.106.7-2.806 2.807-2.806h4.213c2.107 0 2.807.7 2.807 2.806v5.614c0 2.106-.707 2.806-2.807 2.806H4.14z"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgIcInfluencerLiveGray);

/***/ }),

/***/ 51361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgIcInfluencerVideo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.667 6c0-3.333-1.334-4.667-4.667-4.667H6C2.667 1.333 1.333 2.667 1.333 6v4c0 3.333 1.334 4.667 4.667 4.667h4c3.333 0 4.667-1.334 4.667-4.667V6zM1.68 4.74h12.64M5.68 1.407v3.24M10.32 1.407v2.94",
    stroke: "#655AEC"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M6.5 8.833c0-1.026.727-1.446 1.613-.933l.694.4.693.4c.887.513.887 1.353 0 1.867l-.693.4-.694.4c-.886.513-1.613.093-1.613-.934v-.8h0v-.8z",
    stroke: "#A39CF4"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgIcInfluencerVideo);

/***/ }),

/***/ 97039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgIcInfluencerVideoGray(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    stroke: "#888ba6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.667 6c0-3.333-1.334-4.667-4.667-4.667H6C2.667 1.333 1.333 2.667 1.333 6v4c0 3.333 1.334 4.667 4.667 4.667h4c3.333 0 4.667-1.334 4.667-4.667V6zM1.68 4.74h12.64M5.68 1.407v3.24M10.32 1.407v2.94"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M6.5 8.833c0-1.026.727-1.446 1.613-.933l.694.4.693.4c.887.513.887 1.353 0 1.867l-.693.4-.694.4c-.886.513-1.613.093-1.613-.934v-.8h0v-.8z"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgIcInfluencerVideoGray);

/***/ }),

/***/ 73373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgIcInfo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    stroke: "#EC7E00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22 12c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10 10-4.5 10-10z",
    strokeWidth: 1.5,
    opacity: 0.601
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeWidth: 1.5,
    d: "M12 8v5"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeWidth: 2,
    d: "M11.994 16h.009"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgIcInfo);

/***/ }),

/***/ 26879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgIcPlus(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 13V3.002M3.001 8.001h9.998"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgIcPlus);

/***/ }),

/***/ 73425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgIcQuestion(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.667 8c0-3.667-3-6.667-6.667-6.667S1.333 4.333 1.333 8s3 6.667 6.667 6.667 6.667-3 6.667-6.667z",
    stroke: "#A39CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.127 10.494c.343 0 .622.283.622.633 0 .349-.279.632-.622.632a.627.627 0 01-.622-.632c0-.35.278-.633.622-.633zm.833-6.319c.658.265 1.156.8 1.305 1.457.134.595.07 1.117-.186 1.567-.196.346-.488.628-.894.901l-.03.02-.028.019a6.08 6.08 0 01-.03.019l-.014.009c-.173.11-.287.224-.358.342l-.008.013-.007.013-.006.011-.006.01a.434.434 0 00-.002.006l-.006.01a.72.72 0 00-.007.017l-.005.01-.005.011-.004.011a.67.67 0 00-.004.011l-.004.011-.006.017h0l-.003.011-.004.012a.72.72 0 00-.007.03l-.003.012-.003.012-.002.013-.002.013-.003.017-.003.017-.002.02-.002.015-.001.015-.002.015v.016l-.002.024-.001.016-.001.017-.001.026v.018l-.002.028V9.12c0 .276-.22.5-.492.5a.496.496 0 01-.491-.492v-.155l.001-.03v-.02l.001-.02.004-.071.003-.035V8.78l.002-.017.002-.017.001-.008.006-.051.003-.018.002-.017.004-.027c.037-.226.11-.438.23-.639.151-.249.369-.468.659-.656l.014-.009c.683-.437.895-.81.747-1.464-.072-.317-.336-.601-.709-.75a1.412 1.412 0 00-1.226.075c-.546.309-.765.699-.716 1.246l.002.016a.498.498 0 01-.44.548.494.494 0 01-.538-.447c-.096-.965.33-1.737 1.215-2.237a2.378 2.378 0 012.065-.132z",
    stroke: "#655AEC",
    strokeWidth: 0.2,
    fill: "#655AEC",
    fillRule: "nonzero"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgIcQuestion);

/***/ }),

/***/ 14761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgIcRefreshLight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    strokeWidth: 1.556,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M.778 7A6.209 6.209 0 017 .778c2.767 0 4.84 1.153 6.222 3.46m0 0V1.125m0 3.111H10.46",
    stroke: "#000139"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.556 9.763v3.11M13.222 7c0 3.435-2.767 6.222-6.176 6.222-2.273 0-4.103-1.153-5.49-3.46h2.791",
    stroke: "#A0A3BD"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgIcRefreshLight);

/***/ }),

/***/ 29322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgMedal(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    fill: "#FFF",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18.124 9.963l-2.512-1.436c-.951-.54-2.278-.54-3.222 0L9.878 9.97v-.526C9.878 7.87 10.75 7 12.348 7h3.307c1.596 0 2.47.869 2.47 2.444v.519z",
    fill: "#655AEC",
    fillRule: "nonzero"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18.045 11.131l-.965-.546-2.001-1.142c-.61-.35-1.547-.35-2.158 0l-2.001 1.135-.965.56-.128.063c-1.242.827-1.327.98-1.327 2.305v3.165c0 1.324.085 1.478 1.355 2.326l3.066 1.744c.305.182.689.259 1.079.259.383 0 .774-.084 1.079-.26l3.094-1.764c1.249-.827 1.327-.974 1.327-2.305v-3.165c0-1.324-.085-1.478-1.355-2.326l-.1-.049z",
    fill: "#655AEC"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.547 15.579a.503.503 0 00-.113.329l.042.672c.029.414-.27.624-.66.477l-.631-.252a.637.637 0 00-.362 0l-.632.245c-.39.154-.688-.063-.66-.477l.043-.672a.503.503 0 00-.114-.33l-.44-.517c-.27-.316-.149-.666.255-.77l.66-.169a.571.571 0 00.284-.21l.37-.56c.226-.35.588-.35.823 0l.369.56a.561.561 0 00.284.21l.66.168c.404.105.525.455.255.77l-.433.526z",
    fill: "#FEAAFF"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgMedal);

/***/ }),

/***/ 7296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgVideoPlay(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 37,
    height: 37,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "-15%",
    y: "-11.7%",
    width: "130%",
    height: "130%",
    filterUnits: "objectBoundingBox",
    id: "video_play_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feMorphology", {
    radius: 1,
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    dy: 1,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "-31%",
    y: "-20.8%",
    width: "162.1%",
    height: "158.1%",
    filterUnits: "objectBoundingBox",
    id: "video_play_svg__c"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17.956 33c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z",
    id: "video_play_svg__b"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.11 15.84c0-3.12 2.205-4.395 4.905-2.835l2.175 1.26 2.175 1.26c2.7 1.56 2.7 4.11 0 5.67l-2.175 1.26-2.175 1.26c-2.7 1.56-4.905.285-4.905-2.835v-5.04z",
    id: "video_play_svg__d"
  }))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    transform: "translate(1)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#000",
    filter: "url(#video_play_svg__a)",
    xlinkHref: "#video_play_svg__b"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    stroke: "#FFF",
    strokeWidth: 2,
    xlinkHref: "#video_play_svg__b"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(1)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#000",
    filter: "url(#video_play_svg__c)",
    xlinkHref: "#video_play_svg__d"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#video_play_svg__d"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgVideoPlay);

/***/ }),

/***/ 66375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B_": function() { return /* binding */ starProductApi; },
/* harmony export */   "Ck": function() { return /* binding */ getVideoStarListApi; },
/* harmony export */   "D$": function() { return /* binding */ deleteGroupApi; },
/* harmony export */   "EC": function() { return /* binding */ getProductStarListApi; },
/* harmony export */   "Io": function() { return /* binding */ moveGroupApi; },
/* harmony export */   "L$": function() { return /* binding */ starLiveApi; },
/* harmony export */   "Ow": function() { return /* binding */ unStarInfluencerApi; },
/* harmony export */   "Rt": function() { return /* binding */ getLiveStarListApi; },
/* harmony export */   "U3": function() { return /* binding */ getCountApi; },
/* harmony export */   "U6": function() { return /* binding */ starShopApi; },
/* harmony export */   "YF": function() { return /* binding */ setTopGroupApi; },
/* harmony export */   "gS": function() { return /* binding */ getGroupListApi; },
/* harmony export */   "iV": function() { return /* binding */ getShopStarListApi; },
/* harmony export */   "jk": function() { return /* binding */ getInfluencerStarListApi; },
/* harmony export */   "l7": function() { return /* binding */ unStarProductApi; },
/* harmony export */   "oc": function() { return /* binding */ updateGroupApi; },
/* harmony export */   "rZ": function() { return /* binding */ starVideoApi; },
/* harmony export */   "sV": function() { return /* binding */ unStarShopApi; },
/* harmony export */   "sf": function() { return /* binding */ unStarLiveApi; },
/* harmony export */   "uu": function() { return /* binding */ starInfluencerApi; },
/* harmony export */   "vs": function() { return /* binding */ unStarVideoApi; },
/* harmony export */   "yO": function() { return /* binding */ createGroupApi; }
/* harmony export */ });
/* harmony import */ var _api_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84425);

const starVideoApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(`/data/videos/${id}/star`);
};
const unStarVideoApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"](`/data/videos/${id}/unstar`);
};
const getVideoStarListApi = params => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get('/data/videos/star/list', {
    params
  });
};
const starInfluencerApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(`/data/influencers/${id}/star`);
};
const unStarInfluencerApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"](`/data/influencers/${id}/unstar`);
};
const getInfluencerStarListApi = params => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get('/data/influencers/star/list', {
    params
  });
};
const starProductApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(`/data/products/${id}/star`);
};
const unStarProductApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"](`/data/products/${id}/unstar`);
};
const getProductStarListApi = params => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get('/data/products/star/list', {
    params
  });
};
const starLiveApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(`/data/lives/${id}/star`);
};
const unStarLiveApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"](`/data/lives/${id}/unstar`);
};
const getLiveStarListApi = params => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get('/data/lives/star/list', {
    params
  });
};
const starShopApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(`/data/seller/${id}/star`);
};
const unStarShopApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"](`/data/seller/${id}/unstar`);
};
const getShopStarListApi = params => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get('/data/seller/star/list', {
    params
  });
};
const getCountApi = () => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get('/users/collections/stats');
}; // 获取列表

const getGroupListApi = () => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get('/collection-group/list');
}; // 创建分组

const createGroupApi = params => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(`/collection-group/create`, params);
}; // 更新分组

const updateGroupApi = _ref => {
  let {
    id,
    name
  } = _ref;
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(`/collection-group/update/${id}`, {
    name
  });
}; // 分组置顶

const setTopGroupApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get(`/collection-group/set-top/${id}`);
}; // 移动分组

const moveGroupApi = _ref2 => {
  let {
    id,
    group_id
  } = _ref2;
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put(`/collection-group/move-data/${id}`, {
    group_id
  });
}; // 删除分组

const deleteGroupApi = id => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"](`/collection-group/delete/${id}`);
};

/***/ }),

/***/ 7072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_TabsModule__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16321);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10958);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_EchoRadioGroup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82911);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83126);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77303);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23415);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80507);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


const _excluded = ["showDateRange", "tabsList", "activeTab", "setActiveTab", "dateRange", "setDateRange", "style", "startTime", "endTime", "setCustomDateRange", "has180", "hideDate"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











function AnalysisHeader(_ref) {
  let {
    showDateRange,
    tabsList,
    activeTab,
    setActiveTab,
    dateRange,
    setDateRange,
    style = {},
    startTime,
    endTime,
    setCustomDateRange,
    has180,
    hideDate
  } = _ref,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, _excluded);

  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  const otherData = has180 ? [{
    id: '180',
    title: t['influencer.detail.range.180days']
  }] : [];
  const data = [{
    id: '7',
    title: t['influencer.detail.range.7days']
  }, {
    id: '15',
    title: t['influencer.detail.range.15days']
  }, {
    id: '30',
    title: t['influencer.detail.range.30days']
  }, {
    id: '90',
    title: t['influencer.detail.range.90days']
  }, ...otherData];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_8___default().container),
    style: style,
    id: "top-analysis-header",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_TabsModule__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
      type: "text",
      className: "analysis-header-tabs",
      tabsList: tabsList,
      activeTab: activeTab,
      setActiveTab: setActiveTab,
      needScroll: true
    }, rest)), hideDate ? null : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_EchoRadioGroup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        data: data,
        value: dateRange,
        setValue: val => {
          setDateRange(val);
          setCustomDateRange === null || setCustomDateRange === void 0 ? void 0 : setCustomDateRange({
            startTime: '',
            endTime: ''
          });
        }
      }), showDateRange && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"].RangePicker */ .Z.RangePicker, {
          allowClear: false,
          mode: "date",
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_8___default().datePicker),
          triggerProps: {
            // popupVisible: true,
            className: (_index_module_less__WEBPACK_IMPORTED_MODULE_8___default().datePickerPopup)
          } // shortcuts={[
          //   {
          //     text: t['product.filter.yesterday'],
          //     value: () => [dayjs(), dayjs().subtract(1, 'days')]
          //   },
          //   {
          //     text: t['product.filter.last_week'],
          //     value: () => [dayjs(), dayjs().subtract(7, 'days')]
          //   },
          //   {
          //     text: t['product.filter.last_month'],
          //     value: () => [dayjs(), dayjs().subtract(30, 'days')]
          //   }
          // ]}
          ,
          disabledDate: current => current.isAfter(dayjs__WEBPACK_IMPORTED_MODULE_5___default()()),
          defaultPickerValue: [dayjs__WEBPACK_IMPORTED_MODULE_5___default()().month(dayjs__WEBPACK_IMPORTED_MODULE_5___default()().month() - 1), dayjs__WEBPACK_IMPORTED_MODULE_5___default()()],
          value: startTime && endTime ? [dayjs__WEBPACK_IMPORTED_MODULE_5___default().unix(Number(startTime)), dayjs__WEBPACK_IMPORTED_MODULE_5___default().unix(Number(endTime))] : undefined,
          onChange: (_, date) => {
            if (date) {
              const start = date === null || date === void 0 ? void 0 : date[0].unix();
              const end = date === null || date === void 0 ? void 0 : date[1].unix();
              const startDate = dayjs__WEBPACK_IMPORTED_MODULE_5___default().unix(start);
              const endDate = dayjs__WEBPACK_IMPORTED_MODULE_5___default().unix(end);
              const diffInDays = endDate.diff(startDate, 'day');

              if (diffInDays > 1000) {
                _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].warning */ .Z.warning(t['date1000_tips']);
              } else {
                setDateRange('');
                setCustomDateRange === null || setCustomDateRange === void 0 ? void 0 : setCustomDateRange({
                  startTime: String(start),
                  endTime: String(end)
                });
              }
            }
          }
        })
      })]
    })]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (AnalysisHeader);

/***/ }),

/***/ 47989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ GradientText; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _utils_lib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["children", "className", "colors", "animationSpeed", "showBorder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function GradientText(_ref) {
  let {
    children,
    className,
    colors = ['#ffaa40', '#9c40ff', '#ffaa40'],
    animationSpeed = 8,
    showBorder = false
  } = _ref,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  const gradientStyle = {
    backgroundImage: `linear-gradient(to right, ${colors.join(', ')})`,
    animationDuration: `${animationSpeed}s`
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", _objectSpread(_objectSpread({
    className: (0,_utils_lib__WEBPACK_IMPORTED_MODULE_4__.cn)('relative flex max-w-fit flex-row items-center justify-center', 'rounded font-medium backdrop-blur transition-shadow duration-500', 'overflow-hidden cursor-pointer', className)
  }, props), {}, {
    children: [showBorder && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "absolute inset-0 bg-cover z-0 pointer-events-none animate-gradient",
      style: _objectSpread(_objectSpread({}, gradientStyle), {}, {
        backgroundSize: '300% 100%'
      }),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "absolute inset-0 bg-background rounded-[1.25rem] z-[-1]",
        style: {
          width: 'calc(100% - 2px)',
          height: 'calc(100% - 2px)',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "inline-block relative z-2 text-transparent bg-cover animate-gradient",
      style: _objectSpread(_objectSpread({}, gradientStyle), {}, {
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        backgroundSize: '300% 100%'
      }),
      children: children
    })]
  }));
}

/***/ }),

/***/ 86003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var bizcharts_lib_components_Chart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9345);
/* harmony import */ var bizcharts_lib_components_Chart__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bizcharts_lib_components_Chart__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var bizcharts_lib_components_Axis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48226);
/* harmony import */ var bizcharts_lib_components_Axis__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bizcharts_lib_components_Axis__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var bizcharts_lib_components_Legend__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16189);
/* harmony import */ var bizcharts_lib_components_Legend__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bizcharts_lib_components_Legend__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var bizcharts_lib_components_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68325);
/* harmony import */ var bizcharts_lib_components_Tooltip__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(bizcharts_lib_components_Tooltip__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var bizcharts_lib_geometry_Interval__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46194);
/* harmony import */ var bizcharts_lib_geometry_Interval__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(bizcharts_lib_geometry_Interval__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83126);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62258);
/* harmony import */ var _Mask__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2852);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);











function GroupHistogram(_ref) {
  var _Object$keys;

  let {
    data,
    loading,
    blur,
    height = 400,
    yAlias
  } = _ref;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
  let chartIns = null;
  const formatData = [];
  data === null || data === void 0 ? void 0 : data.forEach(trendItem => {
    const cur = formatData.find(item => (item === null || item === void 0 ? void 0 : item.axis_x) === (trendItem === null || trendItem === void 0 ? void 0 : trendItem.axis_x));

    if (cur) {
      cur[trendItem.legend] = trendItem === null || trendItem === void 0 ? void 0 : trendItem.axis_y;
    } else {
      formatData.push({
        axis_x: trendItem === null || trendItem === void 0 ? void 0 : trendItem.axis_x,
        [trendItem.legend]: trendItem === null || trendItem === void 0 ? void 0 : trendItem.axis_y
      });
    }
  });
  const dataAxisList = formatData.length > 0 ? (_Object$keys = Object.keys(formatData === null || formatData === void 0 ? void 0 : formatData[0])) === null || _Object$keys === void 0 ? void 0 : _Object$keys.filter(item => item !== 'axis_x') : [];
  const y = (dataAxisList === null || dataAxisList === void 0 ? void 0 : dataAxisList[0]) || '';
  const z = (dataAxisList === null || dataAxisList === void 0 ? void 0 : dataAxisList[1]) || '';
  const scale = {
    axis_y: {
      alias: yAlias || t['product.detail.alias'],
      tickCount: 7,
      tickInterval: 10
    }
  };
  const label = {
    style: {
      fontSize: 12,
      fill: '#888BA6'
    }
  };
  const legendMap = {};
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    loading: loading,
    style: {
      width: '100%'
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_Mask__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
      isBlur: blur,
      hasBtn: blur,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)((bizcharts_lib_components_Chart__WEBPACK_IMPORTED_MODULE_0___default()), {
        height: height,
        padding: "auto",
        appendPadding: [0, 0, 40, 0],
        data: data,
        autoFit: true,
        scale: scale,
        onGetG2Instance: chart => {
          chart.interaction('active-region', {
            start: [{
              trigger: 'plot:mousemove',
              action: 'active-region:show',
              arg: {
                style: {
                  fill: '#F9F8FAFF'
                }
              }
            }]
          });
          chartIns = chart;
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((bizcharts_lib_components_Axis__WEBPACK_IMPORTED_MODULE_1___default()), {
          name: "axis_y",
          title: true,
          grid: {
            line: {
              type: 'line',
              style: {
                stroke: '#F0F1F8',
                lineWidth: 1,
                lineDash: [6, 4]
              }
            }
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((bizcharts_lib_components_Axis__WEBPACK_IMPORTED_MODULE_1___default()), {
          name: "axis_x",
          label: label,
          line: {
            style: {
              stroke: '#F0F1F8',
              lineWidth: 1,
              lineDash: [6, 4]
            }
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((bizcharts_lib_geometry_Interval__WEBPACK_IMPORTED_MODULE_4___default()), {
          adjust: [{
            type: 'dodge',
            marginRatio: 0
          }],
          color: ['legend', ['#EB54ACE0', '#655AECE0']],
          position: "axis_x*axis_y"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((bizcharts_lib_components_Legend__WEBPACK_IMPORTED_MODULE_2___default()), {
          custom: true,
          allowAllCanceled: true,
          items: [{
            name: y,
            value: y,
            marker: {
              symbol: 'circle',
              style: {
                fill: '#EB54ACE0',
                r: 5
              }
            }
          }, {
            name: z,
            value: z,
            marker: {
              symbol: 'circle',
              style: {
                fill: '#655AECE0',
                r: 5
              }
            }
          }],
          onChange: ev => {
            const {
              item
            } = ev;
            const {
              value
            } = item;
            const checked = !item.unchecked;
            legendMap[value] = checked;
            chartIns.filter('legend', val => {
              return legendMap[val] !== false;
            });
            chartIns.render(true);
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((bizcharts_lib_components_Tooltip__WEBPACK_IMPORTED_MODULE_3___default()), {
          shared: true
        })]
      })
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (GroupHistogram);

/***/ }),

/***/ 26916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var bizcharts_lib_components_Chart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9345);
/* harmony import */ var bizcharts_lib_components_Chart__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bizcharts_lib_components_Chart__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var bizcharts_lib_components_Axis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48226);
/* harmony import */ var bizcharts_lib_components_Axis__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bizcharts_lib_components_Axis__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var bizcharts_lib_components_Legend__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16189);
/* harmony import */ var bizcharts_lib_components_Legend__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bizcharts_lib_components_Legend__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var bizcharts_lib_components_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68325);
/* harmony import */ var bizcharts_lib_components_Tooltip__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(bizcharts_lib_components_Tooltip__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var bizcharts_lib_geometry_Interval__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46194);
/* harmony import */ var bizcharts_lib_geometry_Interval__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(bizcharts_lib_geometry_Interval__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var bizcharts_lib_geometry_LineAdvance__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17308);
/* harmony import */ var bizcharts_lib_geometry_LineAdvance__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(bizcharts_lib_geometry_LineAdvance__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1925);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62258);
/* harmony import */ var _Mask__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2852);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);












/** 双Y轴、折柱面积图，折线图表示总量，柱状图表示增量 */
function LineIntervalArea(_ref) {
  var _Object$keys;

  let {
    data = [],
    height = 300,
    loading = false,
    blur = false
  } = _ref;
  const formatData = data.reduce((acc, cur, idx, arr) => {
    const curItem = acc.find(item => (item === null || item === void 0 ? void 0 : item.axis_x) === (cur === null || cur === void 0 ? void 0 : cur.axis_x));

    if (curItem) {
      curItem[cur.legend] = cur === null || cur === void 0 ? void 0 : cur.axis_y;
    } else {
      acc.push({
        axis_x: cur === null || cur === void 0 ? void 0 : cur.axis_x,
        [cur.legend]: cur === null || cur === void 0 ? void 0 : cur.axis_y
      });
    }

    return acc;
  }, []);
  const dataAxisList = formatData.length > 0 ? (_Object$keys = Object.keys(formatData === null || formatData === void 0 ? void 0 : formatData[0])) === null || _Object$keys === void 0 ? void 0 : _Object$keys.filter(item => item !== 'axis_x') : [];
  const y = (dataAxisList === null || dataAxisList === void 0 ? void 0 : dataAxisList[0]) || '';
  const z = (dataAxisList === null || dataAxisList === void 0 ? void 0 : dataAxisList[1]) || '';
  const zMax = Math.max(...formatData.map(item => item === null || item === void 0 ? void 0 : item[z]));
  let chartIns = null;
  const scale = {
    [y]: {
      alias: y,
      // tickCount: 5,
      min: 0,
      type: 'linear-strict'
    },
    [z]: {
      alias: z,
      // tickCount: 5,
      min: 0,
      // 将右轴拉长，使得增量柱状图只展示在下半图，避免过高超过总量折线
      max: zMax * 2,
      type: 'linear-strict'
    },
    axis_x: {
      mask: 'MM-DD'
    }
  };
  const colors = ['#655AEC', '#EB54AC'];
  const label = {
    style: {
      fontSize: 12,
      fill: '#888BA6'
    },

    formatter(text) {
      return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .formatDigital */ .yK)(Number.isNaN(Number(text)) ? text : Number(text)).join('');
    }

  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    loading: loading,
    style: {
      width: '100%'
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Mask__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
      isBlur: blur,
      hasBtn: blur,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((bizcharts_lib_components_Chart__WEBPACK_IMPORTED_MODULE_0___default()), {
        scale: scale,
        autoFit: true,
        height: height,
        data: formatData,
        onGetG2Instance: chart => {
          chartIns = chart;
        },
        appendPadding: [0, 0, 40, 0],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((bizcharts_lib_components_Axis__WEBPACK_IMPORTED_MODULE_1___default()), {
          title: true,
          name: y,
          label: label,
          grid: {
            line: {
              type: 'line',
              style: {
                stroke: '#D7D9E8',
                lineWidth: 1,
                lineDash: [6, 4]
              }
            }
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((bizcharts_lib_components_Axis__WEBPACK_IMPORTED_MODULE_1___default()), {
          title: true,
          name: z,
          label: label,
          grid: {
            line: {
              type: 'line',
              style: {
                stroke: '#F0F1F8',
                lineWidth: 1,
                lineDash: [6, 4]
              }
            }
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((bizcharts_lib_components_Axis__WEBPACK_IMPORTED_MODULE_1___default()), {
          name: "axis_x",
          label: label,
          line: {
            style: {
              stroke: '#F0F1F8',
              lineWidth: 1,
              lineDash: [6, 4]
            }
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((bizcharts_lib_components_Legend__WEBPACK_IMPORTED_MODULE_2___default()), {
          custom: true,
          allowAllCanceled: true,
          items: [{
            value: y,
            name: y,
            marker: {
              symbol: 'circle',
              style: {
                fill: colors[1],
                r: 5
              }
            }
          }, {
            value: z,
            name: z,
            marker: {
              symbol: 'circle',
              style: {
                fill: colors[0],
                r: 5
              }
            }
          }],
          onChange: ev => {
            const item = ev.item;
            const value = item.value;
            const checked = !item.unchecked;
            const geoms = chartIns.geometries;

            for (let i = 0; i < geoms.length; i++) {
              const geom = geoms[i];

              if (geom.getYScale().field === value) {
                if (checked) {
                  geom.show();
                } else {
                  geom.hide();
                }
              }
            }
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((bizcharts_lib_components_Tooltip__WEBPACK_IMPORTED_MODULE_3___default()), {
          shared: true,
          showCrosshairs: true,
          crosshairs: {
            line: {
              style: {
                stroke: '#D7D9E8',
                lineWidth: 1,
                lineDash: [6, 4]
              }
            }
          },
          showMarkers: true
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((bizcharts_lib_geometry_LineAdvance__WEBPACK_IMPORTED_MODULE_5___default()), {
          shape: "smooth",
          area: true,
          position: `axis_x*${y}`,
          color: colors[1],
          tooltip: [`axis_x*${y}`, (axis_x, yValue) => {
            return {
              name: y,
              value: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .formatDigital */ .yK)(yValue).join(''),
              title: axis_x
            };
          }]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((bizcharts_lib_geometry_Interval__WEBPACK_IMPORTED_MODULE_4___default()), {
          position: `axis_x*${z}`,
          color: colors[0],
          tooltip: [`axis_x*${z}`, (axis_x, zValue) => {
            return {
              name: z,
              value: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .formatDigital */ .yK)(zValue).join(''),
              title: axis_x
            };
          }]
        })]
      })
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (LineIntervalArea);

/***/ }),

/***/ 77960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ CollectedButton; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2687);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56187);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15695);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_ic_header_Star_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71853);
/* harmony import */ var _assets_ic_star_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18842);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37905);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83126);
/* harmony import */ var _hooks_useCollect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11081);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42170);
/* harmony import */ var _components_CollectGroupDropdown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70499);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);

const _excluded = ["id", "type"];












const CollectedButton = props => {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  const {
    overrideClassName = classnames__WEBPACK_IMPORTED_MODULE_6___default()((_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().collectBtn), (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().collected)),
    icon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
      src: _assets_ic_header_Star_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
      width: 16,
      height: 14,
      alt: "star"
    }),
    isLoading,
    onClick,
    triggerProps
  } = props;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    icon: null,
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().popConfirm),
    title: `${t['favorites.cancel.star']}?`,
    okText: t['favorites.cancel.star.yes'],
    cancelText: t['favorites.cancel.star.no'],
    okButtonProps: {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().okButton)
    },
    cancelButtonProps: {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().cancelButton)
    },
    onOk: onClick,
    triggerProps: triggerProps,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      loading: isLoading,
      className: overrideClassName,
      icon: icon
    })
  });
};

const CollectButton = props => {
  const {
    id,
    type
  } = props,
        restProps = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(props, _excluded);

  const {
    isCollected,
    isLoading,
    toggleCollect
  } = (0,_hooks_useCollect__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(restProps);
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  (0,ahooks__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(() => {
    if (isCollected) {
      setPopupVisible(true);
    }
  }, [isCollected]);
  const {
    0: popupVisible,
    1: setPopupVisible
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_CollectGroupDropdown__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    id: id,
    type: type,
    popupVisible: popupVisible,
    onClose: () => {
      setPopupVisible(false);
    },
    children: isCollected ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(CollectedButton, {
      onClick: toggleCollect,
      isLoading: isLoading
    }, "collected") : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
      content: t['collect'],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        loading: isLoading,
        className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().collectBtn), (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().collet)),
        icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
          src: _assets_ic_star_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
          width: 16,
          height: 14,
          alt: "star"
        }),
        onClick: isLoading ? undefined : toggleCollect
      }, "collect")
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CollectButton);

/***/ }),

/***/ 70499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4730);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62258);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2489);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56187);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94990);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83126);
/* harmony import */ var _pages_platform_favorites_hooks_useGetCollectionStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87283);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25617);
/* harmony import */ var _api_favorites__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66375);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95689);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _api_request__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84425);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);



const _excluded = ["popupVisible", "triggerProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












const GroupSelect = props => {
  var _groupList$;

  const {
    id,
    groupId,
    type,
    onClose,
    onMoved
  } = props;
  const {
    group
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(state => state.collection);
  const {
    getFetchCollection,
    loadingGetCollection
  } = (0,_pages_platform_favorites_hooks_useGetCollectionStore__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  const groupList = group[type];
  const {
    0: selected,
    1: setSelected
  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(groupId || ((_groupList$ = groupList[0]) === null || _groupList$ === void 0 ? void 0 : _groupList$.id));
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(groupList)) {
      getFetchCollection();
    }
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().dropdownContent),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().title),
      children: t['favorite.move_group']
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().content),
      children: lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(groupList) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        loading: loadingGetCollection,
        style: {
          width: '100%',
          margin: '3px 0',
          textAlign: 'center'
        }
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Group */ .Z.Group, {
        direction: "vertical",
        defaultValue: groupId || groupList[0].id,
        onChange: setSelected,
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().radioGroup),
        children: groupList.filter(item => item.id !== '').map(item => {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
            className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().radioItem),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
              value: item.id,
              children: item.name
            })
          }, item.id);
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().actions),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().cancelButton),
        onClick: onClose,
        children: t['modal.close']
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        type: "primary",
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().okButton),
        onClick: () => {
          var _groupList$2;

          onClose();
          (0,_api_favorites__WEBPACK_IMPORTED_MODULE_6__/* .moveGroupApi */ .Io)({
            id,
            group_id: selected || ((_groupList$2 = groupList[0]) === null || _groupList$2 === void 0 ? void 0 : _groupList$2.id)
          }).then(_api_request__WEBPACK_IMPORTED_MODULE_7__/* .backendCodeProcessor */ .KA).then(() => {
            onMoved === null || onMoved === void 0 ? void 0 : onMoved();
          });
        },
        children: t['common.list.ok']
      })]
    })]
  });
};

const CollectGroupDropdown = props => {
  const {
    popupVisible,
    triggerProps
  } = props,
        restProps = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(props, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
    popupVisible: popupVisible,
    position: "br",
    triggerProps: _objectSpread({
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default().popup),
      onClickOutside: props.onClose
    }, triggerProps),
    droplist: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(GroupSelect, _objectSpread({}, restProps)),
    children: props.children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CollectGroupDropdown);

/***/ }),

/***/ 70736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56187);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54224);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94990);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81181);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85777);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64895);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _dnd_kit_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94697);
/* harmony import */ var _dnd_kit_modifiers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32339);
/* harmony import */ var _dnd_kit_sortable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45587);
/* harmony import */ var _dnd_kit_utilities__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24285);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83126);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65885);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













const RowContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createContext({});

const DragHandle = () => {
  const {
    setActivatorNodeRef,
    listeners
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(RowContext);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, _objectSpread({
    type: "text",
    size: "small",
    icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
    style: {
      cursor: 'move'
    },
    ref: setActivatorNodeRef
  }, listeners));
};

const Row = props => {
  const {
    dataIndex,
    data,
    onChange
  } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging
  } = (0,_dnd_kit_sortable__WEBPACK_IMPORTED_MODULE_4__/* .useSortable */ .nB)({
    id: dataIndex
  });

  const style = _objectSpread(_objectSpread({}, props.style), {}, {
    transform: _dnd_kit_utilities__WEBPACK_IMPORTED_MODULE_5__/* .CSS.Translate.toString */ .ux.Translate.toString(transform),
    transition
  }, isDragging ? {
    position: 'relative',
    zIndex: 9999
  } : {});

  const contextValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => ({
    setActivatorNodeRef,
    listeners
  }), [setActivatorNodeRef, listeners]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(RowContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", _objectSpread(_objectSpread({
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_10___default().dropItem),
      ref: setNodeRef,
      style: style
    }, attributes), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(DragHandle, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        defaultChecked: (data === null || data === void 0 ? void 0 : data.isSelected) || false,
        onChange: checked => {
          onChange === null || onChange === void 0 ? void 0 : onChange(checked, data);
        },
        style: {
          display: 'flex',
          alignItems: 'center'
        },
        children: data.title
      })]
    }))
  });
};

const DropList = _ref => {
  let {
    defaultFields,
    onOk,
    onCancel,
    visible
  } = _ref;
  const {
    0: dataSource,
    1: setDataSource
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultFields || []);
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();

  const onDragEnd = _ref2 => {
    let {
      active,
      over
    } = _ref2;

    if (active.id !== (over === null || over === void 0 ? void 0 : over.id)) {
      setDataSource(prevState => {
        const activeIndex = prevState.findIndex(record => record.dataIndex === (active === null || active === void 0 ? void 0 : active.id));
        const overIndex = prevState.findIndex(record => record.dataIndex === (over === null || over === void 0 ? void 0 : over.id));
        return (0,_dnd_kit_sortable__WEBPACK_IMPORTED_MODULE_4__/* .arrayMove */ .Rp)(prevState, activeIndex, overIndex);
      });
    }
  };

  const handleChangeSelect = (checked, item) => {
    setDataSource(prevState => {
      const newList = prevState.map(i => i.dataIndex === item.dataIndex ? _objectSpread(_objectSpread({}, i), {}, {
        isSelected: checked
      }) : i);
      return newList;
    });
  };

  const handleSave = () => {
    onOk === null || onOk === void 0 ? void 0 : onOk(dataSource);
    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_10___default().customTableField),
    ref: ref,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_dnd_kit_core__WEBPACK_IMPORTED_MODULE_2__/* .DndContext */ .LB, {
      modifiers: [_dnd_kit_modifiers__WEBPACK_IMPORTED_MODULE_3__/* .restrictToVerticalAxis */ .DL],
      onDragEnd: onDragEnd,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_dnd_kit_sortable__WEBPACK_IMPORTED_MODULE_4__/* .SortableContext */ .Fo, {
        items: dataSource.map(i => i.dataIndex),
        strategy: _dnd_kit_sortable__WEBPACK_IMPORTED_MODULE_4__/* .verticalListSortingStrategy */ .qw,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_10___default().dropList),
          children: dataSource.map((item, index) => {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Row, {
              dataIndex: item.dataIndex,
              data: item,
              onChange: handleChangeSelect
            }, index);
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_10___default().customFooter),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        onClick: () => onCancel === null || onCancel === void 0 ? void 0 : onCancel(),
        children: t['modal.close']
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        type: "primary",
        onClick: handleSave,
        children: t['userSetting.btn.save']
      })]
    })]
  });
};

const CustomField = _ref3 => {
  let {
    defaultFields,
    onOk,
    id
  } = _ref3;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
  const {
    0: visible,
    1: setVisible
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const [localColumns, setLocalColumns] = (0,ahooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(id, {
    defaultValue: []
  });
  const finalColumns = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    return localColumns.map(column => {
      var _defaultFields$find;

      return {
        dataIndex: column.dataIndex,
        isSelected: column.isSelected,
        title: (_defaultFields$find = defaultFields.find(d => d.dataIndex === column.dataIndex)) === null || _defaultFields$find === void 0 ? void 0 : _defaultFields$find.title
      };
    });
  }, [defaultFields, localColumns]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if ((localColumns === null || localColumns === void 0 ? void 0 : localColumns.length) === 0 && defaultFields) {
      setLocalColumns(defaultFields.map(column => {
        return {
          dataIndex: column.dataIndex,
          isSelected: column.isSelected
        };
      }));
    }
  }, [localColumns === null || localColumns === void 0 ? void 0 : localColumns.length, defaultFields]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    popupVisible: visible,
    droplist: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(DropList, {
      defaultFields: finalColumns,
      onCancel: () => setVisible(false),
      onOk: list => {
        onOk === null || onOk === void 0 ? void 0 : onOk(list);
        setLocalColumns(list.map(column => {
          return {
            dataIndex: column.dataIndex,
            isSelected: column.isSelected
          };
        }));
      },
      visible: visible
    }),
    position: "bl",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      style: {
        borderRadius: 8
      },
      type: "outline",
      onClick: () => setVisible(true),
      icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {}),
      children: t['select_fields']
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CustomField);

/***/ }),

/***/ 76262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36792);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_EchoRadioGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82911);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83126);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77303);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23415);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80507);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);

const _excluded = ["showDateRange", "dateRange", "setDateRange", "style", "startTime", "endTime", "setCustomDateRange", "has180"];









function DateSelect(_ref) {
  let {
    showDateRange,
    dateRange,
    setDateRange,
    style = {},
    startTime,
    endTime,
    setCustomDateRange,
    has180
  } = _ref,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const otherData = has180 ? [{
    id: '180',
    title: t['influencer.detail.range.180days']
  }] : [];
  const data = [{
    id: '7',
    title: t['influencer.detail.range.7days']
  }, {
    id: '15',
    title: t['influencer.detail.range.15days']
  }, {
    id: '30',
    title: t['influencer.detail.range.30days']
  }, {
    id: '90',
    title: t['influencer.detail.range.90days']
  }, ...otherData];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().container),
    style: style,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_EchoRadioGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        data: data,
        value: dateRange,
        setValue: val => {
          setDateRange(val);
          setCustomDateRange === null || setCustomDateRange === void 0 ? void 0 : setCustomDateRange({
            startTime: '',
            endTime: ''
          });
        }
      }), showDateRange && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"].RangePicker */ .Z.RangePicker, {
          allowClear: false,
          mode: "date",
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().datePicker),
          triggerProps: {
            // popupVisible: true,
            className: (_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().datePickerPopup)
          } // shortcuts={[
          //   {
          //     text: t['product.filter.yesterday'],
          //     value: () => [dayjs(), dayjs().subtract(1, 'days')]
          //   },
          //   {
          //     text: t['product.filter.last_week'],
          //     value: () => [dayjs(), dayjs().subtract(7, 'days')]
          //   },
          //   {
          //     text: t['product.filter.last_month'],
          //     value: () => [dayjs(), dayjs().subtract(30, 'days')]
          //   }
          // ]}
          ,
          disabledDate: current => current.isAfter(dayjs__WEBPACK_IMPORTED_MODULE_3___default()()),
          defaultPickerValue: [dayjs__WEBPACK_IMPORTED_MODULE_3___default()().month(dayjs__WEBPACK_IMPORTED_MODULE_3___default()().month() - 1), dayjs__WEBPACK_IMPORTED_MODULE_3___default()()],
          value: startTime && endTime ? [dayjs__WEBPACK_IMPORTED_MODULE_3___default().unix(Number(startTime)), dayjs__WEBPACK_IMPORTED_MODULE_3___default().unix(Number(endTime))] : undefined,
          onChange: (_, date) => {
            if (date) {
              const start = date === null || date === void 0 ? void 0 : date[0].unix();
              const end = date === null || date === void 0 ? void 0 : date[1].unix();
              const startDate = dayjs__WEBPACK_IMPORTED_MODULE_3___default().unix(start);
              const endDate = dayjs__WEBPACK_IMPORTED_MODULE_3___default().unix(end);
              const diffInDays = endDate.diff(startDate, 'day');

              if (diffInDays > 1000) {
                _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"].warning */ .Z.warning(t['date1000_tips']);
              } else {
                setDateRange('');
                setCustomDateRange === null || setCustomDateRange === void 0 ? void 0 : setCustomDateRange({
                  startTime: String(start),
                  endTime: String(end)
                });
              }
            }
          }
        })
      })]
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (DateSelect);

/***/ }),

/***/ 2917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EchoCard; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88460);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77589);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["title", "children", "style", "className", "extra"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function EchoCard(_ref) {
  let {
    title,
    children,
    style,
    className = '',
    extra
  } = _ref,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  const combinedClassName = Array.isArray(className) ? [(_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().container), ...className] : [(_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().container), className];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    className: combinedClassName,
    title: title ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().title),
      children: title
    }) : null,
    style: _objectSpread({
      borderRadius: '16px',
      padding: '12px'
    }, style),
    extra: extra ? extra : null
  }, props), {}, {
    children: children
  }));
}

/***/ }),

/***/ 82911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2489);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15695);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97916);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




const RadioGroup = _arco_design_web_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Group */ .Z.Group;

function EchoRadioGroup(_ref) {
  let {
    data,
    value,
    setValue,
    style,
    type
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RadioGroup, {
    type: "button",
    name: "lang",
    value: value,
    onChange: setValue,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()({
      [(_index_module_less__WEBPACK_IMPORTED_MODULE_3___default().container)]: type !== 'divide',
      [(_index_module_less__WEBPACK_IMPORTED_MODULE_3___default()["container-divide"])]: type === 'divide'
    }),
    style: style,
    children: data === null || data === void 0 ? void 0 : data.map(dateItem => {
      if (dateItem.tooltip) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          content: dateItem.tooltip,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            value: dateItem.id,
            disabled: dateItem.disabled,
            children: dateItem.title
          })
        }, dateItem.id);
      }

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        value: dateItem.id,
        disabled: dateItem.disabled,
        children: dateItem.title
      }, dateItem.id);
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (EchoRadioGroup);

/***/ }),

/***/ 73895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_EchoTag; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tag/index.js
var Tag = __webpack_require__(6277);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tooltip/index.js
var Tooltip = __webpack_require__(15695);
;// CONCATENATED MODULE: ./src/assets/trophy.svg
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgTrophy(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M12.79 2.644a.879.879 0 00-.645-.283h-.94V.591H2.798v1.77h-.943a.875.875 0 00-.873.944A6.027 6.027 0 003.28 7.56 4.208 4.208 0 006.3 9.748v1.713h1.4V9.748a4.208 4.208 0 003.022-2.19 6.027 6.027 0 002.295-4.253.873.873 0 00-.227-.66zm-10.935.592h.943v2.368c0 .07.002.138.005.207a5.145 5.145 0 01-.948-2.575zm9.343 2.573a4.55 4.55 0 00.005-.205V3.236h.941A5.145 5.145 0 0111.2 5.81zm-6.762 6.413a.875.875 0 00-.875.875v.728c0 .096.078.175.175.175h6.53a.175.175 0 00.175-.175v-.728a.875.875 0 00-.875-.875h-5.13z",
    fill: "#FCBF28"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.11 0H2.892a.702.702 0 000 1.403h8.22a.702.702 0 100-1.403zM8.33 11.407H5.672a.815.815 0 00-.815.815h4.286a.815.815 0 00-.815-.815z",
    fill: "#FF934A"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M9.109 4.353L7.983 4.25a.257.257 0 01-.206-.14l-.6-1.195a.257.257 0 00-.465.01L6.19 4.1a.257.257 0 01-.21.151l-1.11.102a.257.257 0 00-.125.464l.856.613a.257.257 0 01.092.297l-.4 1.088a.257.257 0 00.36.316l1.18-.618a.257.257 0 01.235-.002l1.249.63a.257.257 0 00.355-.321l-.416-1.088a.257.257 0 01.094-.303l.882-.61a.257.257 0 00-.123-.466z",
    fill: "#FFF"
  }))));
}

/* harmony default export */ var trophy = (SvgTrophy);
;// CONCATENATED MODULE: ./src/assets/ic_arrow_right_rank.svg
var ic_arrow_right_rank_g;

function ic_arrow_right_rank_extends() { ic_arrow_right_rank_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_arrow_right_rank_extends.apply(this, arguments); }



function SvgIcArrowRightRank(props) {
  return /*#__PURE__*/react.createElement("svg", ic_arrow_right_rank_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ic_arrow_right_rank_g || (ic_arrow_right_rank_g = /*#__PURE__*/react.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 16V0h16v16z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M6.74 11.53L10.26 8 6.74 4.47",
    stroke: "#ED9F07",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }))));
}

/* harmony default export */ var ic_arrow_right_rank = (SvgIcArrowRightRank);
// EXTERNAL MODULE: ./src/components/EchoTag/style/index.module.less
var index_module = __webpack_require__(6081);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/EchoTag/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









function EchoTag(_ref) {
  let {
    type,
    name,
    value,
    desc,
    onClick,
    style
  } = _ref;
  const styleMap = {
    certificate: {
      icon: '',
      color: '#655AEC',
      borderColor: '#ADA0EF',
      backgroundColor: '#F3F1FD',
      suffix: ''
    },
    rating: {
      icon: '',
      color: '#655AEC',
      borderColor: '#ADA0EF',
      backgroundColor: '#F3F1FD',
      suffix: ''
    },
    ranking: {
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(trophy, {}),
      color: '#ED9F07',
      borderColor: '#FCBF28',
      backgroundColor: '#FFF1CE',
      suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(ic_arrow_right_rank, {})
    }
  };
  const styleObj = styleMap[type] || styleMap['ranking'];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
    icon: styleObj !== null && styleObj !== void 0 && styleObj.icon ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      children: styleObj === null || styleObj === void 0 ? void 0 : styleObj.icon
    }) : null,
    bordered: true,
    className: (index_module_default()).container,
    style: _objectSpread({
      color: styleObj === null || styleObj === void 0 ? void 0 : styleObj.color,
      borderColor: styleObj === null || styleObj === void 0 ? void 0 : styleObj.borderColor,
      backgroundColor: styleObj === null || styleObj === void 0 ? void 0 : styleObj.backgroundColor,
      cursor: onClick ? 'pointer' : 'default'
    }, style),
    onClick: () => {
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
      content: desc,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        },
        children: [name, value, styleObj === null || styleObj === void 0 ? void 0 : styleObj.suffix]
      })
    })
  }, name);
}

/* harmony default export */ var components_EchoTag = (EchoTag);

/***/ }),

/***/ 21023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94558);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15695);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69609);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32403);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56187);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83126);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91159);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






const Option = _arco_design_web_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Option */ .Z.Option;

// 筛选组件
const FilterItem = _ref => {
  let {
    title,
    data,
    type,
    onChange,
    defaultValue,
    tooltipText
  } = _ref;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  const {
    0: value,
    1: setValue
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined);
  const {
    0: minValue,
    1: setMinValue
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const {
    0: maxValue,
    1: setMaxValue
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const {
    0: popupVisible,
    1: setPopupVisible
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    // 兼容默认值：可能是选项值，或显示串（min-max / >min / <max），或内部自定义编码
    if (defaultValue === undefined || defaultValue === '') {
      setValue('');
      setMinValue(undefined);
      setMaxValue(undefined);
      return;
    }

    if (typeof defaultValue === 'string') {
      const active = data.find(d => d.value === defaultValue);

      if (active) {
        setValue(defaultValue);
        return;
      }

      if (defaultValue.startsWith('__custom__|')) {
        const [, minStr = '', maxStr = ''] = defaultValue.split('|');
        const min = minStr !== '' ? Number(minStr) : undefined;
        const max = maxStr !== '' ? Number(maxStr) : undefined;
        setMinValue(min);
        setMaxValue(max);
        setValue(defaultValue);
        return;
      }

      const rangeMatch = defaultValue.match(/^\s*(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)\s*$/);

      if (rangeMatch) {
        const min = Number(rangeMatch[1]);
        const max = Number(rangeMatch[2]);
        setMinValue(min);
        setMaxValue(max);
        setValue(`__custom__|${min}|${max}`);
        return;
      }

      const gtMatch = defaultValue.match(/^>\s*(\d+(?:\.\d+)?)$/);

      if (gtMatch) {
        const min = Number(gtMatch[1]);
        setMinValue(min);
        setMaxValue(undefined);
        setValue(`__custom__|${min}|`);
        return;
      }

      const ltMatch = defaultValue.match(/^<\s*(\d+(?:\.\d+)?)$/);

      if (ltMatch) {
        const max = Number(ltMatch[1]);
        setMinValue(undefined);
        setMaxValue(max);
        setValue(`__custom__||${max}`);
        return;
      } // 默认认为是选项值


      setValue(defaultValue);
      setMinValue(undefined);
      setMaxValue(undefined);
    }
  }, [defaultValue]);
  const triggerText = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    // 自定义区间显示：min-max / >min / <max
    if (typeof value === 'string' && value !== null && value !== void 0 && value.startsWith('__custom__')) {
      const [, min, max] = value.split('|'); // __custom__|min|max

      const hasMin = !!min;
      const hasMax = !!max;
      const rangeText = hasMin && hasMax ? `${min}-${max}` : hasMin ? `>${min}` : hasMax ? `<${max}` : '';
      return rangeText ? `${title}: ${rangeText}` : title;
    } // 选项显示


    const active = data.find(d => d.value === value);

    if ((active === null || active === void 0 ? void 0 : active.value) === '') {
      return title;
    }

    return active ? `${title}: ${active.label}` : title;
  }, [data, title, value]);

  const handleReset = () => {
    setValue('');
    onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
    setMinValue(undefined);
    setMaxValue(undefined);
    setPopupVisible(false);
  };

  const handleOk = () => {
    const custom = `__custom__|${minValue ?? ''}|${maxValue ?? ''}`;
    setValue(custom);
    setPopupVisible(false);
    const display = minValue !== undefined && maxValue !== undefined ? `${minValue}-${maxValue}` : minValue !== undefined ? `>${minValue}` : maxValue !== undefined ? `<${maxValue}` : '';
    onChange === null || onChange === void 0 ? void 0 : onChange(display || undefined);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().filterSelectWrap),
    children: tooltipText ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      content: tooltipText,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().filterSelectView),
        value: value,
        placeholder: typeof title === 'string' ? title : '',
        popupVisible: popupVisible,
        onClick: () => setPopupVisible(true),
        onVisibleChange: v => setPopupVisible(v),
        renderFormat: () => triggerText,
        triggerProps: {
          autoAlignPopupWidth: false,
          autoAlignPopupMinWidth: true
        },
        dropdownMenuStyle: {
          maxHeight: 350
        },
        dropdownMenuClassName: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().filterSelectPopup),
        onChange: v => {
          setValue(v);
          setMinValue(undefined);
          setMaxValue(undefined);
          setPopupVisible(false);
          onChange === null || onChange === void 0 ? void 0 : onChange(v);
        },
        dropdownRender: menu => {
          if (type === 'selectInput') {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              children: [menu, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                style: {
                  margin: 0
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().customArea),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                  className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().customInputs),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    min: 0,
                    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().customInput),
                    hideControl: true,
                    size: "small",
                    value: minValue,
                    onChange: val => setMinValue(val)
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
                    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().hyphen),
                    children: "-"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    min: 0,
                    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().customInput),
                    hideControl: true,
                    size: "small",
                    value: maxValue,
                    onChange: val => setMaxValue(val)
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                  className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().actions),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    type: "text",
                    size: "small",
                    onClick: handleReset,
                    children: t['common.list.reset']
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().okBtn),
                    type: "primary",
                    size: "small",
                    onClick: handleOk,
                    children: t['common.list.ok']
                  })]
                })]
              })]
            });
          }

          return menu;
        },
        children: data === null || data === void 0 ? void 0 : data.map(item => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Option, {
          value: item.value,
          children: item.label
        }, item.value))
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().filterSelectView),
      value: value,
      placeholder: typeof title === 'string' ? title : '',
      popupVisible: popupVisible,
      onClick: () => setPopupVisible(true),
      onVisibleChange: v => setPopupVisible(v),
      renderFormat: () => triggerText,
      triggerProps: {
        autoAlignPopupWidth: false,
        autoAlignPopupMinWidth: true
      },
      dropdownMenuStyle: {
        maxHeight: 350
      },
      dropdownMenuClassName: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().filterSelectPopup),
      onChange: v => {
        setValue(v);
        setMinValue(undefined);
        setMaxValue(undefined);
        setPopupVisible(false);
        onChange === null || onChange === void 0 ? void 0 : onChange(v);
      },
      dropdownRender: menu => {
        if (type === 'selectInput') {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            children: [menu, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              style: {
                margin: 0
              }
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().customArea),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().customInputs),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                  min: 0,
                  className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().customInput),
                  hideControl: true,
                  size: "small",
                  value: minValue,
                  onChange: val => setMinValue(val)
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
                  className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().hyphen),
                  children: "-"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                  min: 0,
                  className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().customInput),
                  hideControl: true,
                  size: "small",
                  value: maxValue,
                  onChange: val => setMaxValue(val)
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().actions),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                  type: "text",
                  size: "small",
                  onClick: handleReset,
                  children: t['common.list.reset']
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                  className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().okBtn),
                  type: "primary",
                  size: "small",
                  onClick: handleOk,
                  children: t['common.list.ok']
                })]
              })]
            })]
          });
        }

        return menu;
      },
      children: data === null || data === void 0 ? void 0 : data.map(item => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Option, {
        value: item.value,
        children: item.label
      }, item.value))
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterItem);

/***/ }),

/***/ 56844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Introduction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83126);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67588);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






function Introduction(_ref) {
  let {
    contentHtml,
    containerClassName,
    containerStyle,
    defaultIsExpand = false
  } = _ref;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const {
    0: isExpand,
    1: setIsExpand
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultIsExpand);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().introduction),
    style: containerStyle,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      dangerouslySetInnerHTML: {
        __html: contentHtml
      },
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().line), {
        [(_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().lineExpand)]: isExpand
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().more), {
        [(_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().moreExpand)]: isExpand
      }),
      onClick: () => {
        setIsExpand(!isExpand);
      },
      children: isExpand ? t['introduction.collapse'] : t['introduction.expand']
    })]
  });
}

/***/ }),

/***/ 88076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qk": function() { return /* binding */ getFirstLevelPath; },
/* harmony export */   "eu": function() { return /* binding */ toDashed; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77754);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function toDashed(str) {
  return str.replace(/([A-Z])/g, match => `-${match.toLowerCase()}`).replace(/_/g, '-').toLowerCase();
}
const getFirstLevelPath = path => {
  if (!path) {
    return '';
  } // 去掉两端的斜杠


  path = path.replace(/^\/|\/$/g, ''); // 查找第一个斜杠的位置

  const index = path.indexOf('/');

  if (index === -1) {
    // 如果没有斜杠，则直接返回原字符串
    return '/' + path;
  } else {
    // 如果有斜杠，则返回第一个斜杠之前的字符串
    return '/' + path.substring(0, index);
  }
};

const LinkSeo = _ref => {
  let {
    href,
    name
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_2___default().linkSeo),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
      href: href,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
        children: name || (typeof href === 'string' ? href : '')
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (LinkSeo);

/***/ }),

/***/ 19790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ManualRecordModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_EchoModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28330);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80507);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77303);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56187);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1393);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72097);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86776);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83126);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42586);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74169);
/* harmony import */ var _hooks_useIsZh__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);










function ManualRecordModal(_ref) {
  let {
    visible,
    onCancel,
    successCallback,
    type
  } = _ref;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const {
    0: confirmLoading,
    1: setConfirmLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const {
    0: shareUrl,
    1: setShareUrl
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('');
  const {
    0: isShowGuide,
    1: setIsShowGuide
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const isZh = (0,_hooks_useIsZh__WEBPACK_IMPORTED_MODULE_4__/* .useIsZh */ .r)();
  const srcList = isZh ? ['https://static.echotik.live/assets/record.webp'] : ['https://static.echotik.live/assets/record_en.webp'];

  const handleConfirm = async () => {
    try {
      setConfirmLoading(true);
      const res = type === 'product' ? await (0,_api_common__WEBPACK_IMPORTED_MODULE_3__/* .getManualRecordProductApi */ .SM)(shareUrl) : await (0,_api_common__WEBPACK_IMPORTED_MODULE_3__/* .getManualRecordShopApi */ .EF)(shareUrl);

      if (res.data.code === _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .SUCCESS_CODE */ .Gh) {
        _arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"].success */ .Z.success(t['manual_record_success']);
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        successCallback === null || successCallback === void 0 ? void 0 : successCallback(res.data.data);
      }

      setConfirmLoading(false);
    } catch (error) {
      _arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"].error */ .Z.error(t['manual_record_fail']);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_EchoModal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    isAutoContent: true,
    confirmLoading: confirmLoading,
    visible: visible,
    onCancel: () => onCancel === null || onCancel === void 0 ? void 0 : onCancel(),
    footer: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: "flex justify-between items-center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
        className: "text-primary cursor-pointer",
        onClick: () => setIsShowGuide(true),
        children: t['use_guide']
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          className: "rounded-xl",
          onClick: () => onCancel === null || onCancel === void 0 ? void 0 : onCancel(),
          children: t['modal.cancel']
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          type: "primary",
          className: "rounded-xl",
          onClick: handleConfirm,
          children: t['common.list.ok']
        })]
      })]
    }),
    title: type === 'product' ? t['manual_record_product'] : t['manual_record_shop'],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("span", {
        children: [type === 'product' ? t['manual_record_product_tips'] : t['manual_record_shop_tips'], ":"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        value: shareUrl,
        onChange: val => setShareUrl(val),
        placeholder: type === 'product' ? t['manual_record_product_placeholder'] : t['manual_record_shop_placeholder'],
        style: {
          minWidth: 294
        }
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"].PreviewGroup */ .Z.PreviewGroup, {
      srcList: srcList,
      visible: isShowGuide,
      onVisibleChange: setIsShowGuide
    })]
  });
}

/***/ }),

/***/ 20025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fd": function() { return /* binding */ NotLoginBasicCard; },
  "lO": function() { return /* binding */ NotLoginListCard; },
  "ZP": function() { return /* binding */ components_NotLoginChartCard; }
});

// UNUSED EXPORTS: NotLoginInfluencerCard

// EXTERNAL MODULE: ./src/components/EchoCard/index.tsx
var components_EchoCard = __webpack_require__(2917);
;// CONCATENATED MODULE: ./src/assets/chart_bg.png
/* harmony default export */ var chart_bg = ({"src":"/_next/static/media/chart_bg.d9d16f7b.png","height":1578,"width":2856,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAIAAAA8r+mnAAAAUUlEQVR42iWJSw6AMAgFe/9butHETX8KFB5UEiezmGQKWKNLdI7G3jhD75erFF9AFWuCtOaQehANLQAiYsMTc8Tev0Wn0kVyPjYWltkUsEHsAyb4XRgS25sdAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/assets/list_bg.png
/* harmony default export */ var list_bg = ({"src":"/_next/static/media/list_bg.bede0248.png","height":1136,"width":2758,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAIAAAAhqtkfAAAANUlEQVR42k2GSQoAIAzE+v+filftNi044sUQQsTMwxNZydDAG9nb1jKgaKGLvbTMMVSdR38OR9BGSAB7chIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/assets/basic_bg.png
/* harmony default export */ var basic_bg = ({"src":"/_next/static/media/basic_bg.cb63f91c.png","height":526,"width":2780,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACBAMAAACXuoDeAAAAFVBMVEX8/Pz7+/z6+vz6+vv5+fz5+fv39/nWf96VAAAAEklEQVR42mNIdXJ1YhA2EBQEAAolAZR1lbgXAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/influencer_bg.png
/* harmony default export */ var influencer_bg = ({"src":"/_next/static/media/influencer_bg.2da8b3dd.png","height":1302,"width":2812,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAIAAAA8r+mnAAAAQUlEQVR42iWKCQoAMQwC+//3NtHEFNZtYfBAF8AqIUs6xUE20KRWpgBFuI+zg9Us/NZ7V0aTx8TmHaD3tZIDPPQBLk5dDqkM+9cAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/NotLoginChartCard/index.tsx








const NotLoginChartCard = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_EchoCard/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: chart_bg.src,
      width: 1400,
      height: 400
    })
  });
};

const NotLoginListCard = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_EchoCard/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: list_bg.src,
      width: 1400,
      height: 300
    })
  });
};
const NotLoginBasicCard = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_EchoCard/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: basic_bg.src,
      width: 1400,
      height: 270
    })
  });
};
const NotLoginInfluencerCard = () => {
  return /*#__PURE__*/_jsx(EchoCard, {
    children: /*#__PURE__*/_jsx(Image, {
      src: influencerBg.src,
      width: 1400,
      height: 650
    })
  });
};
/* harmony default export */ var components_NotLoginChartCard = (NotLoginChartCard);

/***/ }),

/***/ 50510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var qrcode_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84059);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(77303);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69609);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9582);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(15734);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15695);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(27339);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83126);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(84566);
/* harmony import */ var _assets_ic_header_Refresh_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72304);
/* harmony import */ var _assets_ic_header_Link_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26575);
/* harmony import */ var _assets_ic_header_Qrcode_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35242);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42820);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _components_TabsModule__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16321);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _hooks_useShareBtn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16809);
/* harmony import */ var _hooks_usePageNavPosition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67767);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);

const _excluded = ["children"];
















function PageNav(_ref) {
  let {
    onRefresh,
    tabsList,
    activeTab,
    setActiveTab,
    collectBtnHook,
    name,
    link,
    images
  } = _ref;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const imgUrl = images === null || images === void 0 ? void 0 : images[0];
  const navRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const shareBtnHook = (0,_hooks_useShareBtn__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
  const {
    contentWidth,
    leftMenuWidth
  } = (0,_hooks_usePageNavPosition__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
    contentRef
  });
  const currentSecondNav = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    var _tabsList$find;

    return ((_tabsList$find = tabsList.find(tab => tab.nodeName === activeTab)) === null || _tabsList$find === void 0 ? void 0 : _tabsList$find.tabList) || [];
  }, [activeTab, tabsList]);

  const handleSecondNavClick = tab => {
    const anchorName = document.getElementById(tab.nodeName);
    const container = document.getElementById('layout-content-wrapper');

    if (anchorName && container) {
      const containerRect = container.getBoundingClientRect();
      const anchorRect = anchorName.getBoundingClientRect();
      const scrollTop = container.scrollTop;
      const targetScrollTop = scrollTop + anchorRect.top - containerRect.top - 64 - 30;
      container.scrollTo({
        top: targetScrollTop,
        behavior: 'smooth'
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    id: "page-nav",
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default().container),
    ref: navRef,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default().content),
      ref: contentRef,
      style: {
        width: contentWidth,
        left: leftMenuWidth
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default().contentNav),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_TabsModule__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default()["page-nav-tabs"]),
          tabsList: tabsList.map(_ref2 => {
            let {
              children
            } = _ref2,
                other = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ref2, _excluded);

            return other;
          }),
          activeTab: activeTab,
          setActiveTab: setActiveTab,
          scrollToTop: true
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default().secondContent),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            split: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
              type: "vertical"
            }),
            children: currentSecondNav.map((tab, index) => {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default().secondNavItem),
                onClick: () => handleSecondNavClick(tab),
                children: tab.title
              }, index);
            })
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default()["info-wrapper"]),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
          direction: "horizontal",
          size: 40,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            direction: "horizontal",
            size: 8,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
              size: 44,
              className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default()["info-avatar"]),
              children: imgUrl ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                src: imgUrl,
                alt: name
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              direction: "vertical",
              size: 0,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default()["info-wrapper-content"]),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                  className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default()["info-wrapper-text"]),
                  children: name
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"].Text */ .Z.Text, {
                  copyable: {
                    text: name
                  }
                })]
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            size: 16,
            children: [shareBtnHook.renderForNav(), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
              mini: true,
              content: t['product.detail.refresh'],
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                onClick: onRefresh,
                className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default()["action-btn"]),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                  alt: "refresh",
                  src: _assets_ic_header_Refresh_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === null || _assets_ic_header_Refresh_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === void 0 ? void 0 : _assets_ic_header_Refresh_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                  width: 18,
                  height: 18
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
              mini: true,
              content: t['product.detail.tiktokLink'],
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default()["action-btn"]),
                onClick: () => {
                  window.open(`${link}`);
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                  alt: "link",
                  src: _assets_ic_header_Link_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === null || _assets_ic_header_Link_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === void 0 ? void 0 : _assets_ic_header_Link_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                  width: 20,
                  height: 18
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
              mini: true,
              content: t['product.detail.tiktokQrcode'],
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                title: "",
                content: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(qrcode_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                  value: link // 二维码的大小
                  ,
                  size: 100 // 二维码的颜色
                  ,
                  fgColor: "#333333",
                  style: {
                    margin: 'auto'
                  }
                }),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                  className: (_index_module_less__WEBPACK_IMPORTED_MODULE_11___default()["action-btn"]),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                    alt: "qrcode",
                    src: _assets_ic_header_Qrcode_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === null || _assets_ic_header_Qrcode_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === void 0 ? void 0 : _assets_ic_header_Qrcode_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
                    width: 18,
                    height: 18
                  })
                })
              })
            }), collectBtnHook.renderForNav({
              getPopupContainer: () => navRef.current
            })]
          })]
        })
      })]
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (PageNav);

/***/ }),

/***/ 34915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2489);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58589);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


const _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const RadioGroup = props => {
  const {
    className
  } = props,
        restProps = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Group */ .Z.Group, _objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().radioGroup), className)
  }, restProps));
};

/* harmony default export */ __webpack_exports__["Z"] = (RadioGroup);

/***/ }),

/***/ 57832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94558);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43374);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


const _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const Select = props => {
  const {
    className
  } = props,
        restProps = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().select), className)
  }, restProps));
};

/* harmony default export */ __webpack_exports__["Z"] = (Select);

/***/ }),

/***/ 25470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_StatisticCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tooltip/index.js
var Tooltip = __webpack_require__(15695);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/index.js + 5 modules
var Image = __webpack_require__(72097);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js + 1 modules
var Button = __webpack_require__(56187);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Space/index.js
var Space = __webpack_require__(77303);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Spin/index.js + 1 modules
var Spin = __webpack_require__(62258);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/clock.svg
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgClock(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M8 14.667A6.67 6.67 0 011.333 8 6.67 6.67 0 018 1.333 6.67 6.67 0 0114.667 8 6.67 6.67 0 018 14.667z",
    stroke: "#403D5A"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10.473 10.12L8.407 8.887c-.36-.214-.654-.727-.654-1.147V5.007",
    stroke: "#A0A3BD"
  }))));
}

/* harmony default export */ var clock = (SvgClock);
;// CONCATENATED MODULE: ./src/assets/heart.svg
var _path;

function heart_extends() { heart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return heart_extends.apply(this, arguments); }



function SvgHeart(props) {
  return /*#__PURE__*/react.createElement("svg", heart_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.587 13.873c-1.934-.66-6.254-3.413-6.254-8.08 0-2.06 1.66-3.726 3.707-3.726 1.213 0 2.287.586 2.96 1.493a3.686 3.686 0 012.96-1.493c2.047 0 3.707 1.666 3.707 3.726 0 4.667-4.32 7.42-6.254 8.08-.226.08-.6.08-.826 0z",
    stroke: "#403D5A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  })));
}

/* harmony default export */ var heart = (SvgHeart);
;// CONCATENATED MODULE: ./src/assets/message.svg
var message_g;

function message_extends() { message_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return message_extends.apply(this, arguments); }



function SvgMessage(props) {
  return /*#__PURE__*/react.createElement("svg", message_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), message_g || (message_g = /*#__PURE__*/react.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M5.333 12.667c-2.666 0-4-.667-4-4V5.333c0-2.666 1.334-4 4-4h5.334c2.666 0 4 1.334 4 4v3.334c0 2.666-1.334 4-4 4h-.334c-.206 0-.406.1-.533.266l-1 1.334c-.44.586-1.16.586-1.6 0l-1-1.334a.754.754 0 00-.533-.266h-.334z",
    stroke: "#403D5A",
    strokeWidth: 1.2
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#A0A3BD",
    strokeWidth: 1.333,
    d: "M10.664 7.333h.006M7.996 7.333h.006M5.33 7.333h.006"
  }))));
}

/* harmony default export */ var message = (SvgMessage);
;// CONCATENATED MODULE: ./src/assets/play-circle.svg
var play_circle_g;

function play_circle_extends() { play_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return play_circle_extends.apply(this, arguments); }



function SvgPlayCircle(props) {
  return /*#__PURE__*/react.createElement("svg", play_circle_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), play_circle_g || (play_circle_g = /*#__PURE__*/react.createElement("g", {
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M7.98 14.667a6.667 6.667 0 110-13.334 6.667 6.667 0 010 13.334z",
    stroke: "#403D5A"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5.827 7.04c0-1.387.98-1.953 2.18-1.26l.966.56.967.56c1.2.693 1.2 1.827 0 2.52l-.967.56-.966.56c-1.2.693-2.18.127-2.18-1.26V7.04z",
    stroke: "#A0A3BD"
  }))));
}

/* harmony default export */ var play_circle = (SvgPlayCircle);
;// CONCATENATED MODULE: ./src/assets/share.svg
var share_g;

function share_extends() { share_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return share_extends.apply(this, arguments); }



function SvgShare(props) {
  return /*#__PURE__*/react.createElement("svg", share_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), share_g || (share_g = /*#__PURE__*/react.createElement("g", {
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("g", {
    fillRule: "nonzero",
    stroke: "#A0A3BD"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M8.667 7.333l5.467-5.467M14.666 4.533v-3.2h-3.2"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M7.333 1.333H6C2.667 1.333 1.333 2.667 1.333 6v4c0 3.333 1.334 4.667 4.667 4.667h4c3.333 0 4.667-1.334 4.667-4.667V8.667",
    stroke: "#403D5A"
  }))));
}

/* harmony default export */ var share = (SvgShare);
// EXTERNAL MODULE: ./src/assets/video_play.svg
var video_play = __webpack_require__(7296);
;// CONCATENATED MODULE: ./src/assets/ic_heart_light.svg
var ic_heart_light_path;

function ic_heart_light_extends() { ic_heart_light_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_heart_light_extends.apply(this, arguments); }



function SvgIcHeartLight(props) {
  return /*#__PURE__*/react.createElement("svg", ic_heart_light_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ic_heart_light_path || (ic_heart_light_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.587 13.873c-1.934-.66-6.254-3.413-6.254-8.08 0-2.06 1.66-3.726 3.707-3.726 1.213 0 2.287.586 2.96 1.493a3.686 3.686 0 012.96-1.493c2.047 0 3.707 1.666 3.707 3.726 0 4.667-4.32 7.42-6.254 8.08-.226.08-.6.08-.826 0z",
    stroke: "#FFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  })));
}

/* harmony default export */ var ic_heart_light = (SvgIcHeartLight);
;// CONCATENATED MODULE: ./src/assets/ic_message_light.svg
var ic_message_light_g;

function ic_message_light_extends() { ic_message_light_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_message_light_extends.apply(this, arguments); }



function SvgIcMessageLight(props) {
  return /*#__PURE__*/react.createElement("svg", ic_message_light_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ic_message_light_g || (ic_message_light_g = /*#__PURE__*/react.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M5.333 12.667c-2.666 0-4-.667-4-4V5.333c0-2.666 1.334-4 4-4h5.334c2.666 0 4 1.334 4 4v3.334c0 2.666-1.334 4-4 4h-.334c-.206 0-.406.1-.533.266l-1 1.334c-.44.586-1.16.586-1.6 0l-1-1.334a.754.754 0 00-.533-.266h-.334z",
    strokeWidth: 1.2
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 1.333,
    d: "M10.664 7.333h.006M7.996 7.333h.006M5.33 7.333h.006"
  }))));
}

/* harmony default export */ var ic_message_light = (SvgIcMessageLight);
;// CONCATENATED MODULE: ./src/assets/ic_play_light.svg
var ic_play_light_g;

function ic_play_light_extends() { ic_play_light_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_play_light_extends.apply(this, arguments); }



function SvgIcPlayLight(props) {
  return /*#__PURE__*/react.createElement("svg", ic_play_light_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ic_play_light_g || (ic_play_light_g = /*#__PURE__*/react.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M7.98 14.667a6.667 6.667 0 110-13.334 6.667 6.667 0 010 13.334z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5.827 7.04c0-1.387.98-1.953 2.18-1.26l.966.56.967.56c1.2.693 1.2 1.827 0 2.52l-.967.56-.966.56c-1.2.693-2.18.127-2.18-1.26V7.04z"
  }))));
}

/* harmony default export */ var ic_play_light = (SvgIcPlayLight);
;// CONCATENATED MODULE: ./src/assets/ic_share_light.svg
var ic_share_light_g;

function ic_share_light_extends() { ic_share_light_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_share_light_extends.apply(this, arguments); }



function SvgIcShareLight(props) {
  return /*#__PURE__*/react.createElement("svg", ic_share_light_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ic_share_light_g || (ic_share_light_g = /*#__PURE__*/react.createElement("g", {
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M8.667 7.333l5.467-5.467M14.666 4.533v-3.2h-3.2"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M7.333 1.333H6C2.667 1.333 1.333 2.667 1.333 6v4c0 3.333 1.334 4.667 4.667 4.667h4c3.333 0 4.667-1.334 4.667-4.667V8.667"
  }))));
}

/* harmony default export */ var ic_share_light = (SvgIcShareLight);
;// CONCATENATED MODULE: ./src/assets/video_large.png
/* harmony default export */ var video_large = ({"src":"/_next/static/media/video_large.7fddb458.png","height":200,"width":114,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAIBAMAAADD3ygIAAAAGFBMVEX5+f339/z29vz29vv09Prz8/nm5/Hk5fArtbLjAAAAIUlEQVR42mMQUhJgEDYWYDBkNGAQTRFgEC0Bs8FiQkYKADHmAzuZSjMJAAAAAElFTkSuQmCC","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/video_large_2.png
/* harmony default export */ var video_large_2 = ({"src":"/_next/static/media/video_large_2.c09c1e8b.png","height":260,"width":200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAIBAMAAAAo6JMLAAAAGFBMVEX4+P34+Pz39/z29vvm5/Hl5vDk5fDi5O8neQGMAAAAIElEQVR42mMwMlZmUDY2YjASUGYwSgHiUiAWgIoZKwMARwoEbgjnWtsAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/live-large.png
/* harmony default export */ var live_large = ({"src":"/_next/static/media/live-large.77b988d0.png","height":200,"width":114,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAIBAMAAADD3ygIAAAAG1BMVEX4+P339/z39/v29vv09Prz9Pnz8/nn6PLk5fDgLyLqAAAAHklEQVR42mMQMhZgEAZiQ0YDBpFSAQaxNghbGCIOADYDA2F7kgCLAAAAAElFTkSuQmCC","blurWidth":5,"blurHeight":8});
// EXTERNAL MODULE: ./src/assets/user2x.png
var user2x = __webpack_require__(87707);
// EXTERNAL MODULE: ./src/assets/shop2x.png
var shop2x = __webpack_require__(81186);
;// CONCATENATED MODULE: ./src/assets/eye.svg
var eye_g;

function eye_extends() { eye_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return eye_extends.apply(this, arguments); }



function SvgEye(props) {
  return /*#__PURE__*/react.createElement("svg", eye_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), eye_g || (eye_g = /*#__PURE__*/react.createElement("g", {
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M8 10.387A2.384 2.384 0 015.613 8 2.384 2.384 0 018 5.613 2.384 2.384 0 0110.387 8 2.384 2.384 0 018 10.387z",
    stroke: "#A0A3BD"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.073 9.727c.6-.94.6-2.52 0-3.46C12.547 3.867 10.353 2.48 8 2.48S3.453 3.867 1.927 6.267c-.6.94-.6 2.52 0 3.46 1.526 2.4 3.72 3.786 6.073 3.786s4.547-1.386 6.073-3.786z",
    stroke: "#403D5A"
  }))));
}

/* harmony default export */ var eye = (SvgEye);
;// CONCATENATED MODULE: ./src/assets/ranking.svg
var ranking_g;

function ranking_extends() { ranking_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ranking_extends.apply(this, arguments); }



function SvgRanking(props) {
  return /*#__PURE__*/react.createElement("svg", ranking_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ranking_g || (ranking_g = /*#__PURE__*/react.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M2.667 9.333c-.734 0-1.334.6-1.334 1.334v4H5.78V9.333H2.667z",
    stroke: "#403D5A"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M7.107 6.667c-.734 0-1.334.6-1.334 1.333v6.667h4.447V8c0-.733-.593-1.333-1.333-1.333h-1.78zM10.22 11.333v3.334h4.447v-2c0-.734-.6-1.334-1.334-1.334H10.22z",
    stroke: "#403D5A"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M8.7 2.087c.047.1.173.193.28.206l.64.107c.407.067.507.367.213.653l-.5.5a.426.426 0 00-.106.36l.14.614c.113.486-.147.673-.574.42l-.6-.354a.412.412 0 00-.393 0l-.6.354c-.427.253-.687.066-.573-.42l.14-.614a.42.42 0 00-.107-.36l-.493-.493c-.294-.293-.2-.587.213-.653l.64-.107a.444.444 0 00.28-.207l.353-.706c.194-.387.5-.387.694-.007l.353.707z",
    stroke: "#A0A3BD"
  }))));
}

/* harmony default export */ var ranking = (SvgRanking);
;// CONCATENATED MODULE: ./src/assets/status-up.svg
var status_up_g;

function status_up_extends() { status_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return status_up_extends.apply(this, arguments); }



function SvgStatusUp(props) {
  return /*#__PURE__*/react.createElement("svg", status_up_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), status_up_g || (status_up_g = /*#__PURE__*/react.createElement("g", {
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    stroke: "#A0A3BD",
    d: "M4.587 12.1v-1.38M8 12.1V9.34M11.413 12.1V7.953"
  }), /*#__PURE__*/react.createElement("g", {
    fillRule: "nonzero",
    stroke: "#A0A3BD"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M11.413 3.9l-.306.36a12.588 12.588 0 01-6.52 4.026"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M9.46 3.9h1.954v1.946",
    strokeLinejoin: "round"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M10 14.667c3.333 0 4.667-1.334 4.667-4.667V6c0-3.333-1.334-4.667-4.667-4.667H6C2.667 1.333 1.333 2.667 1.333 6v4c0 3.333 1.334 4.667 4.667 4.667h4z",
    stroke: "#403D5A",
    strokeLinejoin: "round"
  }))));
}

/* harmony default export */ var status_up = (SvgStatusUp);
;// CONCATENATED MODULE: ./src/assets/wallet-money.svg
var wallet_money_g;

function wallet_money_extends() { wallet_money_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return wallet_money_extends.apply(this, arguments); }



function SvgWalletMoney(props) {
  return /*#__PURE__*/react.createElement("svg", wallet_money_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), wallet_money_g || (wallet_money_g = /*#__PURE__*/react.createElement("g", {
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("g", {
    fillRule: "nonzero",
    stroke: "#A0A3BD"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M7.166 12.593c0 1.147-1.066 2.074-2.38 2.074-1.313 0-2.386-.927-2.386-2.074V11.24c0 1.147 1.066 1.96 2.386 1.96 1.314 0 2.38-.82 2.38-1.96v1.353z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M6.913 10.313c-.393.647-1.2 1.053-2.133 1.053s-1.74-.413-2.133-1.053a1.749 1.749 0 01-.254-.907c0-.573.267-1.086.694-1.46.433-.38 1.026-.606 1.686-.606.66 0 1.254.233 1.687.606.44.367.707.887.707 1.46 0 .334-.094.64-.254.907z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M7.166 11.24c0 1.147-1.066 1.96-2.38 1.96-1.313 0-2.386-.82-2.386-1.96V9.407c0-1.147 1.066-2.074 2.386-2.074.66 0 1.254.234 1.687.607.427.373.693.893.693 1.467v1.833z"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M14.667 8.687a.684.684 0 01-.667.68h-1.307c-.72 0-1.38-.527-1.44-1.247-.04-.42.12-.813.4-1.087.247-.253.587-.4.96-.4H14a.684.684 0 01.667.68v1.374z",
    stroke: "#403D5A"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M1.333 7V5.667c0-1.814 1.094-3.08 2.794-3.294.173-.026.353-.04.54-.04h6c.173 0 .34.007.5.034 1.72.2 2.833 1.473 2.833 3.3v.966h-1.387c-.373 0-.713.147-.96.4-.28.274-.44.667-.4 1.087.06.72.72 1.247 1.44 1.247H14v.966c0 2-1.333 3.334-3.333 3.334H9",
    stroke: "#403D5A"
  }))));
}

/* harmony default export */ var wallet_money = (SvgWalletMoney);
// EXTERNAL MODULE: ./src/components/Mask/index.tsx
var Mask = __webpack_require__(2852);
// EXTERNAL MODULE: ./src/components/StatisticCard/index.module.less
var index_module = __webpack_require__(41646);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/VideoModal/index.tsx
var VideoModal = __webpack_require__(60518);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconPlayArrow/index.js
var IconPlayArrow = __webpack_require__(29008);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconSearch/index.js
var IconSearch = __webpack_require__(22208);
// EXTERNAL MODULE: ./src/utils/useLocale.ts
var useLocale = __webpack_require__(83126);
// EXTERNAL MODULE: ./src/utils/is.ts
var is = __webpack_require__(1405);
// EXTERNAL MODULE: ./src/components/EchoNextImage/index.tsx
var EchoNextImage = __webpack_require__(6406);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/StatisticCard/index.tsx


const _excluded = ["loading", "blur"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


































function StatisticCard(props) {
  const {
    type = 'normal',
    icon,
    title,
    count,
    total,
    totalDesc,
    loading,
    unit,
    averageData,
    detail,
    liveDetail
  } = props;
  const router = (0,next_router.useRouter)();
  const {
    0: visible,
    1: setVisible
  } = (0,react.useState)(false);
  const {
    0: url,
    1: setUrl
  } = (0,react.useState)('');
  const t = (0,useLocale/* default */.Z)();

  if (type === 'video') {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default())["video-item"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default())["video-title"],
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default())["video-content"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          onClick: () => {
            if (detail !== null && detail !== void 0 && detail.share_url) {
              setUrl(detail.share_url);
              setVisible(true);
            } else {
              (detail === null || detail === void 0 ? void 0 : detail.video_url) && window.open(detail === null || detail === void 0 ? void 0 : detail.video_url, '_blank');
            }
          },
          style: detail !== null && detail !== void 0 && detail.video_url ? {
            cursor: 'pointer'
          } : {
            cursor: 'auto'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EchoNextImage/* default */.Z, {
            src: (detail === null || detail === void 0 ? void 0 : detail.cover_url) || (live_large === null || live_large === void 0 ? void 0 : live_large.src),
            alt: "video-cover",
            width: 114,
            height: 200,
            className: (index_module_default())["video-img"],
            preview: false // onError={({ currentTarget }) => {
            //   currentTarget.onerror = null // prevents looping
            //   currentTarget.src = IconLiveLarge?.src
            // }}

          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default())["product-video-Montmorillonite"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(video_play/* default */.Z, {})
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default())["video-info"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-info-item"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(clock, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: detail === null || detail === void 0 ? void 0 : detail.duration
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-info-item"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(play_circle, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: detail === null || detail === void 0 ? void 0 : detail.views_count
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-info-item"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(heart, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: detail === null || detail === void 0 ? void 0 : detail.likes_count
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-info-item"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: detail === null || detail === void 0 ? void 0 : detail.comments_count
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-info-item"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(share, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: detail === null || detail === void 0 ? void 0 : detail.shares_count
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        content: detail === null || detail === void 0 ? void 0 : detail.video_title,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default())["video-footer"],
          onClick: () => {
            detail !== null && detail !== void 0 && detail.video_id ? router.push('/videos/' + detail.video_id) : '';
          },
          children: detail === null || detail === void 0 ? void 0 : detail.video_title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VideoModal/* VideoModal */.K, {
        videoId: detail === null || detail === void 0 ? void 0 : detail.video_id,
        visible: visible,
        url: url,
        onCancel: () => {
          setVisible(false);
          setUrl('');
        }
      })]
    });
  }

  if (type === 'live') {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default())["video-item"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default())["video-title"],
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default())["video-content"],
        onClick: () => {
          (liveDetail === null || liveDetail === void 0 ? void 0 : liveDetail.live_id) && window.open(`/live/${liveDetail.live_id}`, '_blank');
        },
        style: liveDetail !== null && liveDetail !== void 0 && liveDetail.live_id ? {
          cursor: 'pointer'
        } : {
          cursor: 'auto'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
          src: (liveDetail === null || liveDetail === void 0 ? void 0 : liveDetail.reflow_cover) || (video_large === null || video_large === void 0 ? void 0 : video_large.src),
          alt: "reflow-cover",
          width: 114,
          height: 200,
          className: (index_module_default())["video-img"],
          preview: false // error={IcVideo}
          ,
          onError: _ref => {
            let {
              currentTarget
            } = _ref;
            currentTarget.onerror = null; // prevents looping

            currentTarget.src = video_large === null || video_large === void 0 ? void 0 : video_large.src;
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default())["video-info"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-info-item"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(clock, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: liveDetail === null || liveDetail === void 0 ? void 0 : liveDetail.duration
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-info-item"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(eye, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: liveDetail === null || liveDetail === void 0 ? void 0 : liveDetail.total_views_cnt
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-info-item"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ranking, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: liveDetail === null || liveDetail === void 0 ? void 0 : liveDetail.max_views_cnt
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-info-item"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(status_up, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: liveDetail === null || liveDetail === void 0 ? void 0 : liveDetail.total_sale_cnt
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-info-item"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(wallet_money, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: liveDetail === null || liveDetail === void 0 ? void 0 : liveDetail.total_gmv_amt
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default())["video-footer"],
        children: liveDetail === null || liveDetail === void 0 ? void 0 : liveDetail.title
      })]
    });
  }

  if (type === 'video-card') {
    var _detail$product, _detail$product2, _detail$product3, _detail$product4, _detail$product5, _detail$influencer;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default())["video-card"],
      children: [!(0,is/* isEmpty */.xb)(detail === null || detail === void 0 ? void 0 : detail.product) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default())["video-card-content-back"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default())["video-card-content"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            position: 'absolute'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(EchoNextImage/* default */.Z, {
            src: (detail === null || detail === void 0 ? void 0 : detail.cover_url) || (video_large_2 === null || video_large_2 === void 0 ? void 0 : video_large_2.src),
            alt: "video-card",
            width: 200,
            height: 246,
            preview: false,
            style: {
              borderRadius: 8
            },
            onError: _ref2 => {
              let {
                currentTarget
              } = _ref2;
              currentTarget.onerror = null; // prevents looping

              currentTarget.src = video_large_2 === null || video_large_2 === void 0 ? void 0 : video_large_2.src;
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default())["video-card-content-info-wrap"],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-card-content-info"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default())["video-card-content-info-item"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ic_play_light, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (index_module_default())["video-card-content-num"],
                children: detail === null || detail === void 0 ? void 0 : detail.play_count
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default())["video-card-content-info-item"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ic_heart_light, {
                className: (index_module_default())["video-card-content-icon"]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (index_module_default())["video-card-content-num"],
                children: detail === null || detail === void 0 ? void 0 : detail.digg_count
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default())["video-card-content-info-item"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ic_message_light, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (index_module_default())["video-card-content-num"],
                children: detail === null || detail === void 0 ? void 0 : detail.comment_count
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default())["video-card-content-info-item"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ic_share_light, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (index_module_default())["video-card-content-num"],
                children: detail === null || detail === void 0 ? void 0 : detail.share_count
              })]
            })]
          })
        }), !(0,is/* isEmpty */.xb)(detail === null || detail === void 0 ? void 0 : detail.product) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default())["video-card-content-product-wrap"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default())["video-card-content-product-img-wrap"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
              src: detail === null || detail === void 0 ? void 0 : (_detail$product = detail.product) === null || _detail$product === void 0 ? void 0 : _detail$product.cover_url,
              alt: "video-card",
              width: 58,
              className: (index_module_default())["video-card-content-product-img"],
              height: 58,
              preview: false,
              onError: _ref3 => {
                let {
                  currentTarget
                } = _ref3;
                currentTarget.onerror = null; // prevents looping

                currentTarget.src = shop2x/* default */.Z === null || shop2x/* default */.Z === void 0 ? void 0 : shop2x/* default.src */.Z.src;
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-card-content-product-info"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default())["video-card-content-product-title"],
              children: detail === null || detail === void 0 ? void 0 : (_detail$product2 = detail.product) === null || _detail$product2 === void 0 ? void 0 : _detail$product2.product_name
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default())["video-card-content-product-item"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: t['influencer.detail.sales.table.Sales']
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: detail === null || detail === void 0 ? void 0 : (_detail$product3 = detail.product) === null || _detail$product3 === void 0 ? void 0 : _detail$product3.video_sale_cnt
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default())["video-card-content-product-item"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: t['influencer.detail.sales.table.GMV']
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: detail === null || detail === void 0 ? void 0 : (_detail$product4 = detail.product) === null || _detail$product4 === void 0 ? void 0 : _detail$product4.video_gmv_amt
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default())["video-card-footer"],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-card-btn-wrap"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconPlayArrow/* default */.Z, {}),
              className: (index_module_default())["video-card-btn"],
              onClick: () => {
                if (detail !== null && detail !== void 0 && detail.share_url) {
                  setUrl(detail.share_url);
                  setVisible(true);
                } else {
                  (detail === null || detail === void 0 ? void 0 : detail.video_url) && window.open(detail === null || detail === void 0 ? void 0 : detail.video_url, '_blank');
                }
              },
              children: "Play"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconSearch/* default */.Z, {}),
              className: (index_module_default())["video-card-btn"],
              onClick: () => {
                (detail === null || detail === void 0 ? void 0 : detail.video_id) && window.open(`${window.location.origin}/videos/${detail.video_id}`, '_blank');
              },
              children: "View Detail"
            }), (detail === null || detail === void 0 ? void 0 : (_detail$product5 = detail.product) === null || _detail$product5 === void 0 ? void 0 : _detail$product5.product_id) && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconSearch/* default */.Z, {}),
              className: (index_module_default())["video-card-btn"],
              onClick: () => {
                var _detail$product6;

                window.open(`${window.location.origin}/products/${detail === null || detail === void 0 ? void 0 : (_detail$product6 = detail.product) === null || _detail$product6 === void 0 ? void 0 : _detail$product6.product_id}`, '_blank');
              },
              children: "View Product"
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default())["video-card-author"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default())["video-card-author-title"],
          children: detail === null || detail === void 0 ? void 0 : detail.video_title
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default())["video-card-author-influencer"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: detail === null || detail === void 0 ? void 0 : (_detail$influencer = detail.influencer) === null || _detail$influencer === void 0 ? void 0 : _detail$influencer.avatar_url,
            alt: "avatar",
            width: 44,
            height: 44,
            preview: false,
            className: (index_module_default())["video-card-author-avatar"],
            onError: _ref4 => {
              let {
                currentTarget
              } = _ref4;
              currentTarget.onerror = null; // prevents looping

              currentTarget.src = user2x/* default */.Z === null || user2x/* default */.Z === void 0 ? void 0 : user2x/* default.src */.Z.src;
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["video-card-author-influencer-right"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default())["video-card-author-name"],
              children: detail === null || detail === void 0 ? void 0 : detail.nick_name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default())["video-card-author-time"],
              children: detail === null || detail === void 0 ? void 0 : detail.create_time
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VideoModal/* VideoModal */.K, {
        videoId: detail === null || detail === void 0 ? void 0 : detail.video_id,
        visible: visible,
        url: url,
        onCancel: () => {
          setVisible(false);
          setUrl('');
        }
      })]
    });
  }

  if (type === 'main') {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).main,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        width: 44,
        height: 44,
        className: (index_module_default()).icon,
        src: icon,
        alt: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Mask/* default */.ZP, {
          isBlur: (0,is/* isBlurValue */.r7)(count),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).count,
            children: [(0,is/* isBlurValue */.r7)(count) ? `888` : count, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (index_module_default()).unit,
              children: unit
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default()).title,
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).total,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default())["total-desc"],
            children: totalDesc
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default())["total-num"],
            children: total
          })]
        })]
      })]
    });
  }

  if (type === 'normal') {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).item,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default())["header-desc"],
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default())["header-num"],
          children: count
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Space/* default */.Z, {
        direction: "vertical",
        style: {
          width: '100%'
        },
        children: averageData === null || averageData === void 0 ? void 0 : averageData.map((item, index) => {
          if (index < averageData.length - 1) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).averages,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (index_module_default())["average-wrap"],
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (index_module_default())["average-desc"],
                  children: item.desc
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (index_module_default())["average-num"],
                  children: item.num
                })]
              })
            }, index);
          } else {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default())["average-wrap"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (index_module_default())["average-desc"],
                children: item.desc
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (index_module_default())["average-num"],
                children: item.num
              })]
            }, index);
          }
        })
      })]
    });
  }
}

function StatisticCardWrap(_ref5) {
  let {
    loading = false,
    blur = false
  } = _ref5,
      props = (0,objectWithoutProperties/* default */.Z)(_ref5, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Spin/* default */.Z, {
    loading: loading,
    style: {
      width: '100%'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Mask/* default */.ZP, {
      isBlur: blur,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StatisticCard, _objectSpread({}, props))
    })
  });
}

/* harmony default export */ var components_StatisticCard = (StatisticCardWrap);

/***/ }),

/***/ 70474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56187);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15695);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48525);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11367);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9726);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70451);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78234);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83126);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








const ButtonGroup = _arco_design_web_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Group */ .Z.Group;

const TypeSettingSwitch = _ref => {
  let {
    defaultIsTable,
    onChange
  } = _ref;
  const [curIsTable, {
    set
  }] = (0,ahooks__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(false);
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  (0,ahooks__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(() => {
    if (typeof defaultIsTable === 'boolean') {
      set(defaultIsTable);
    }
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_6___default()["select-types"]),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(ButtonGroup, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        content: t['cover_mode'],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          type: "outline",
          shape: "round",
          style: {
            width: 36
          },
          onClick: () => {
            onChange(false);
            set(false);
          },
          icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
          className: classnames__WEBPACK_IMPORTED_MODULE_0___default()({
            [`${(_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().typeSelected)}`]: !curIsTable
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        content: t['table_mode'],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          onClick: () => {
            onChange(true);
            set(true);
          },
          icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
          shape: "round",
          type: "outline",
          className: classnames__WEBPACK_IMPORTED_MODULE_0___default()({
            [`${(_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().typeSelected)}`]: curIsTable
          }),
          style: {
            width: 36
          }
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TypeSettingSwitch);

/***/ }),

/***/ 38297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15695);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5434);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83126);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





const VideoAiButton = _ref => {
  let {
    size = 32
  } = _ref;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    content: t['ai_script_extract'],
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      style: {
        width: size,
        height: size,
        background: 'linear-gradient(45deg, #4A00E0, #8E2DE2)',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 8px rgba(74, 0, 224, 0.5)',
        animation: 'pulse 2s infinite',
        cursor: 'pointer'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_3__/* .MdOutlineAutoAwesome */ .g9S, {
        size: size * 0.6,
        color: "#fff"
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (VideoAiButton);

/***/ }),

/***/ 58330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_VideoButton; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/ic-video.png
/* harmony default export */ var ic_video = ({"src":"/_next/static/media/ic-video.3ea53f52.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAANlBMVEXr7fTr7PP39/r////+/v74+fv4+Pr39/r////5+vv5+fv19fbx8fLl5efW19rS0tbJyc7GxsvDSWZ3AAAACHRSTlNaWvH+/v7+/tS3A7AAAAAySURBVHjaRYu3EQAgDMQeE/yYvP+yVJhOd5IQxDSbAMJIJgostt2ZKpRrnsHi4OrHb79ELwHjVGdkZgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tooltip/index.js
var Tooltip = __webpack_require__(15695);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js + 1 modules
var Button = __webpack_require__(56187);
// EXTERNAL MODULE: ./src/components/VideoModal/index.tsx
var VideoModal = __webpack_require__(60518);
// EXTERNAL MODULE: ./src/utils/useLocale.ts
var useLocale = __webpack_require__(83126);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/VideoButton/index.tsx









const VideoButton = _ref => {
  let {
    url,
    record
  } = _ref;
  const t = (0,useLocale/* default */.Z)();
  const {
    0: visible,
    1: setVisible
  } = (0,react.useState)(false);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
      content: t['common.list.video_play'],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        style: {
          background: 'transparent'
        },
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: ic_video === null || ic_video === void 0 ? void 0 : ic_video.src,
          width: 32,
          height: 32
        }),
        onClick: () => {
          url && setVisible(true);
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(VideoModal/* VideoModal */.K, {
      visible: visible,
      onCancel: () => setVisible(false),
      url: url,
      videoId: record === null || record === void 0 ? void 0 : record.video_id
    })]
  });
};

/* harmony default export */ var components_VideoButton = (VideoButton);

/***/ }),

/***/ 60518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ VideoModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80507);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29735);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15695);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56187);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(62258);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(71809);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29008);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8438);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(28394);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83126);
/* harmony import */ var _hooks_useGetMember__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68217);
/* harmony import */ var _hooks_useGoLogin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94586);
/* harmony import */ var _VideoAiButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74169);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42586);
/* harmony import */ var _hooks_useCurrentRegion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17106);
/* harmony import */ var _utils_region__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37101);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);















const VideoModal = props => {
  const {
    visible,
    onCancel,
    url,
    videoId
  } = props;
  const {
    0: loading,
    1: setLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  const iframe = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  const {
    0: downloadLoading,
    1: setDownloadLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const {
    isLogin
  } = (0,_hooks_useGetMember__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const {
    goLogin
  } = (0,_hooks_useGoLogin__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const {
    0: watchOnAppLoading,
    1: setWatchOnAppLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const {
    0: watchOnAppVisible,
    1: setWatchOnAppVisible
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const {
    0: videoUrl,
    1: setVideoUrl
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('');
  const {
    region
  } = (0,_hooks_useCurrentRegion__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
  const isSoutheastAsia = region === _utils_region__WEBPACK_IMPORTED_MODULE_8__/* .Region.VN */ .y.VN || region === _utils_region__WEBPACK_IMPORTED_MODULE_8__/* .Region.MY */ .y.MY || region === _utils_region__WEBPACK_IMPORTED_MODULE_8__/* .Region.PH */ .y.PH || region === _utils_region__WEBPACK_IMPORTED_MODULE_8__/* .Region.TH */ .y.TH || region === _utils_region__WEBPACK_IMPORTED_MODULE_8__/* .Region.ID */ .y.ID;

  const handleWatchOnApp = async () => {
    setWatchOnAppVisible(true);

    if (videoId) {
      try {
        setWatchOnAppLoading(true);
        const resData = await (0,_api_common__WEBPACK_IMPORTED_MODULE_6__/* .getDownloadVideoApi */ .PT)(videoId);

        if (resData.data.code === _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .SUCCESS_CODE */ .Gh) {
          setVideoUrl(resData.data.data.video_url);
        } else {
          _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].error */ .Z.error(resData.data.msg);
        }

        setWatchOnAppLoading(false);
      } catch (error) {
        _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].error */ .Z.error('Error obtaining video address');
        setWatchOnAppLoading(false);
      }
    } else {
      _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].error */ .Z.error('videoId is missing');
    }
  };

  const onload = () => {
    setLoading(false);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setLoading(true);
  }, [url]);

  const handleDownloadVideo = async () => {
    if (!isLogin) {
      goLogin();
      return;
    }

    if (videoId) {
      try {
        setDownloadLoading(true);
        const close = _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].loading */ .Z.loading(t['download_video_loading'] || 'Downloading...');
        const resData = await (0,_api_common__WEBPACK_IMPORTED_MODULE_6__/* .getDownloadVideoApi */ .PT)(videoId);

        if (resData.data.code === _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .SUCCESS_CODE */ .Gh) {
          const videoUrl = resData.data.data.video_url;

          try {
            // 尝试使用 fetch 下载（解决跨域问题）
            const response = await fetch(videoUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `video_${videoId}.mp4`;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); // 释放 blob URL

            window.URL.revokeObjectURL(blobUrl);
            close();
            _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].success */ .Z.success(t['download_video_success'] || 'Download successful');
          } catch (fetchError) {
            // 如果 fetch 失败（可能是跨域），回退到直接打开链接
            const link = document.createElement('a');
            link.href = videoUrl;
            link.download = `video_${videoId}.mp4`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            close();
            _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].success */ .Z.success(t['download_video_success'] || 'Download successful');
          }
        } else {
          close();
          _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].error */ .Z.error(resData.data.msg);
        }

        setDownloadLoading(false);
      } catch (error) {
        close();
        _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].error */ .Z.error(t['download_video_error']);
        setDownloadLoading(false);
      }
    } else {
      _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].error */ .Z.error(t['download_video_error']);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      title: null,
      maskClosable: false,
      visible: visible,
      footer: null,
      onCancel: () => {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
      },
      style: {
        width: 420
      },
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default()["video-modal"]),
      unmountOnExit: true,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        style: {
          color: '#fff',
          paddingLeft: '6px',
          width: 330,
          paddingBottom: 4
        },
        children: t['network_desc']
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        style: {
          position: 'absolute',
          left: 380,
          top: 80
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
          href: `/tool/ai/tiktok-video-script?videoId=${videoId}`,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
            target: "_blank",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_VideoAiButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        style: {
          position: 'absolute',
          left: 365,
          top: 130
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          content: t['ss_tips'],
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            type: "text",
            loading: downloadLoading,
            onClick: handleDownloadVideo,
            icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {}),
            style: {
              color: '#fff'
            },
            className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default()["download-btn"]),
            children: t['download_video']
          })
        })
      }), isSoutheastAsia && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        style: {
          position: 'absolute',
          left: 365,
          top: 220
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          content: t['watch_on_app_desc'],
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            type: "text",
            onClick: handleWatchOnApp,
            icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {}),
            style: {
              color: '#fff'
            },
            className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default()["download-btn"]),
            children: t['watch_on_app']
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        style: {
          position: 'absolute',
          left: 365,
          top: 180
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          type: "text",
          onClick: () => {
            window.open(`https://www.tiktok.com/@fediukstore/video/${videoId}`, '_blank');
          },
          icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {}),
          style: {
            color: '#fff'
          },
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default()["download-btn"]),
          children: t['watch_on_official_website']
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
        loading: loading,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          style: {
            display: 'flex',
            justifyContent: 'center'
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("iframe", {
            ref: iframe,
            src: url,
            width: "332px",
            height: "776px",
            onLoad: onload,
            style: {
              border: 0,
              borderRadius: 8,
              overflow: 'hidden'
            }
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        visible: watchOnAppVisible,
        onCancel: () => setWatchOnAppVisible(false),
        closable: true,
        title: t['watch_on_app'],
        className: "rounded-2xl w-[400px] h-[766px]",
        footer: null,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
          loading: watchOnAppLoading,
          block: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: "h-full",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("video", {
              src: videoUrl,
              width: "100%",
              height: "100%",
              controls: true
            })
          })
        })
      })]
    })
  });
};

/***/ }),

/***/ 4196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_VideoTitleColumn; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Space/index.js
var Space = __webpack_require__(77303);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tooltip/index.js
var Tooltip = __webpack_require__(15695);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tag/index.js
var Tag = __webpack_require__(6277);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/index.js + 5 modules
var Image = __webpack_require__(72097);
// EXTERNAL MODULE: ./src/assets/video-play2x.png
var video_play2x = __webpack_require__(77354);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/VideoModal/index.tsx
var VideoModal = __webpack_require__(60518);
// EXTERNAL MODULE: ./src/components/VideoTitleColumn/index.module.less
var index_module = __webpack_require__(81976);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/assets/video_play.svg
var video_play = __webpack_require__(7296);
// EXTERNAL MODULE: ./src/utils/useLocale.ts
var useLocale = __webpack_require__(83126);
// EXTERNAL MODULE: ./src/components/EchoNextImage/index.tsx
var EchoNextImage = __webpack_require__(6406);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCheck/index.js
var IconCheck = __webpack_require__(34553);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCopy/index.js
var IconCopy = __webpack_require__(38460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Copy/index.tsx





function Copy(_ref) {
  let {
    text
  } = _ref;
  const t = (0,useLocale/* default */.Z)();
  const {
    0: isCopied,
    1: setIsCopied
  } = (0,react.useState)(false);
  const {
    0: isError,
    1: setIsError
  } = (0,react.useState)(false);
  const successMessage = t['product.detail.copySuccess'];
  const errorMessage = t['product.detail.copyError'];

  const handleCopy = async () => {
    try {
      // 检查是否支持 clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        // 降级方案：使用传统的 execCommand
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }

      setIsCopied(true);
      setIsError(false); // 2秒后重置状态

      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (err) {
      console.error('复制失败:', err);
      setIsError(true);
      setIsCopied(false); // 3秒后重置错误状态

      setTimeout(() => {
        setIsError(false);
      }, 3000);
    }
  };

  const getTooltipContent = () => {
    if (isCopied) return successMessage;
    if (isError) return errorMessage;
    return t['tool.ai.detail.copy'];
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
    content: getTooltipContent(),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "cursor-pointer",
      onClick: handleCopy,
      children: isCopied ? /*#__PURE__*/(0,jsx_runtime.jsx)(IconCheck/* default */.Z, {
        className: "text-green-600"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(IconCopy/* default */.Z, {})
    })
  });
}
;// CONCATENATED MODULE: ./src/components/VideoTitleColumn/index.tsx













// 单独抽离第一栏信息展示，将tooltip展示改为受控
const VideoTitleColumn = _ref => {
  let {
    value,
    record,
    canPlay,
    isGoTiktok
  } = _ref;
  const {
    0: showTooltip,
    1: setShowTooltip
  } = (0,react.useState)(false);
  const {
    0: visible,
    1: setVisible
  } = (0,react.useState)(false);
  const t = (0,useLocale/* default */.Z)();
  const share_url = record === null || record === void 0 ? void 0 : record.share_url;
  const borderRadius = '8px';
  const videoUrl = isGoTiktok ? `${record.video_url || ''}` : `/videos/${record.video_id}`;
  const isLatest = Number(record.is_latest) === 1;

  const playImg = () => {
    if (share_url) {
      setVisible(true);
    } else {
      (record === null || record === void 0 ? void 0 : record.video_url) && window.open(record === null || record === void 0 ? void 0 : record.video_url, '_blank');
    }
  };

  if (canPlay && share_url) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).imgWrap,
        onClick: () => {
          playImg();
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EchoNextImage/* default */.Z, {
          src: record.cover_url,
          alt: "video-cover",
          width: 88,
          height: 88,
          preview: false,
          style: {
            borderRadius: borderRadius
          },
          onError: _ref2 => {
            let {
              currentTarget
            } = _ref2;
            currentTarget.onerror = null; // prevents looping

            currentTarget.src = video_play2x/* default */.Z === null || video_play2x/* default */.Z === void 0 ? void 0 : video_play2x/* default.src */.Z.src;
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default())["product-video-Montmorillonite"],
          style: {
            borderRadius: borderRadius
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(video_play/* default */.Z, {})
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: videoUrl,
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          target: "_blank",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
            direction: "vertical",
            children: [record.highlight ? /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
              content: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                dangerouslySetInnerHTML: {
                  __html: record.highlight
                }
              }),
              popupVisible: showTooltip,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                onMouseEnter: () => setShowTooltip(true),
                onMouseLeave: () => setShowTooltip(false),
                onClick: () => {
                  setShowTooltip(false);
                },
                style: {
                  color: '#403d5a'
                },
                dangerouslySetInnerHTML: {
                  __html: record.highlight
                }
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
              content: record.video_title,
              popupVisible: showTooltip,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                onMouseEnter: () => setShowTooltip(true),
                onMouseLeave: () => setShowTooltip(false),
                onClick: () => {
                  setShowTooltip(false);
                },
                style: {
                  color: '#403d5a'
                },
                children: value
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
              align: "center",
              children: [isLatest && /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                content: t['video.tips.is_new'],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
                  color: "#FFD7DB",
                  defaultChecked: true,
                  style: {
                    color: '#E70A23'
                  },
                  size: "small",
                  children: t['filter.is_new']
                })
              }), record.is_promote && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  display: 'flex',
                  alignItems: 'center'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                  content: t['is_promote'],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
                    color: "orangered",
                    size: "small",
                    children: t['promote']
                  })
                })
              }), record.is_ai_video === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  display: 'flex',
                  alignItems: 'center'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                  content: t['is_ai_video'],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
                    color: "blue",
                    size: "small",
                    children: t['is_ai_video']
                  })
                })
              })]
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Copy, {
        text: record.video_title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VideoModal/* VideoModal */.K, {
        url: share_url,
        visible: visible,
        onCancel: () => setVisible(false),
        videoId: record.video_id
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: `/videos/${record.video_id}`,
    passHref: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      target: "_blank",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
          src: record.cover_url,
          alt: "video-cover",
          width: 88,
          height: 88,
          preview: false,
          style: {
            borderRadius: '8px'
          },
          onError: _ref3 => {
            let {
              currentTarget
            } = _ref3;
            currentTarget.onerror = null; // prevents looping

            currentTarget.src = video_play2x/* default */.Z === null || video_play2x/* default */.Z === void 0 ? void 0 : video_play2x/* default.src */.Z.src;
          },
          onClick: () => {
            setShowTooltip(false);
            window.open(`/videos/${record.video_id}`, '_blank');
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
          direction: "vertical",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
            content: record.video_title,
            popupVisible: showTooltip,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              onMouseEnter: () => setShowTooltip(true),
              onMouseLeave: () => setShowTooltip(false),
              onClick: () => {
                setShowTooltip(false);
              },
              style: {
                color: '#403d5a'
              },
              children: value
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
            align: "center",
            children: [isLatest && /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
              content: t['shop.tips.is_new'],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
                color: "#FFD7DB",
                defaultChecked: true,
                style: {
                  color: '#E70A23'
                },
                size: "small",
                children: t['filter.is_new']
              })
            }), record.is_promote && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                display: 'flex',
                alignItems: 'center'
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                content: t['is_promote'],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
                  color: "orangered",
                  defaultChecked: true,
                  size: "small",
                  children: t['promote']
                })
              })
            })]
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var components_VideoTitleColumn = (VideoTitleColumn);

/***/ }),

/***/ 88747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83126);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77303);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15695);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27339);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(56187);
/* harmony import */ var _assets_ic_refresh_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25369);
/* harmony import */ var _assets_ic_qrcode_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80065);
/* harmony import */ var _assets_ic_link_dark_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94219);
/* harmony import */ var qrcode_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84059);
/* harmony import */ var _style_header_module_less__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22497);
/* harmony import */ var _style_header_module_less__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_style_header_module_less__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _assets_ic_plus_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26879);
/* harmony import */ var _hooks_useShareBtn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16809);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);













const DetailsOperation = _ref => {
  let {
    type,
    onRefresh,
    updateTime,
    profileUrl,
    creativeCenterUrl,
    onClick,
    collectBtnHook,
    extraButton,
    hideQrcode,
    addVideoClick
  } = _ref;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  const shareBtnHook = (0,_hooks_useShareBtn__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    size: 16,
    children: [type === 'product' && extraButton, type !== 'shop' && shareBtnHook.renderForOperation(), onRefresh && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      mini: true,
      content: t['influencer.detail.refresh'],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        onClick: onRefresh,
        className: (_style_header_module_less__WEBPACK_IMPORTED_MODULE_11___default()["action-btn"]),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
          src: _assets_ic_refresh_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z === null || _assets_ic_refresh_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z === void 0 ? void 0 : _assets_ic_refresh_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
          width: 20,
          height: 20,
          alt: "refresh"
        })
      })
    }), type === 'hashtag' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      mini: true,
      content: t['hashtag.detail.creative_center_url'],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: (_style_header_module_less__WEBPACK_IMPORTED_MODULE_11___default()["action-btn"]),
        onClick: () => {
          creativeCenterUrl && window.open(`${creativeCenterUrl}`);
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
          src: _assets_ic_link_dark_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === null || _assets_ic_link_dark_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === void 0 ? void 0 : _assets_ic_link_dark_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
          width: 20,
          height: 20,
          alt: "link"
        })
      })
    }), type !== 'shop' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      mini: true,
      content: t['influencer.detail.tiktokLink'],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: (_style_header_module_less__WEBPACK_IMPORTED_MODULE_11___default()["action-btn"]),
        onClick: () => {
          window.open(`${profileUrl}`);
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
          src: _assets_ic_link_dark_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === null || _assets_ic_link_dark_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === void 0 ? void 0 : _assets_ic_link_dark_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
          width: 20,
          height: 20,
          alt: "link"
        })
      })
    }), hideQrcode ? null : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      mini: true,
      content: t['influencer.detail.tiktokQrcode'],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        title: "",
        position: 'bottom',
        content: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(qrcode_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
          value: profileUrl,
          size: 100 // 二维码的大小
          ,
          fgColor: "#333333",
          style: {
            margin: 'auto'
          }
        }),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: (_style_header_module_less__WEBPACK_IMPORTED_MODULE_11___default()["action-btn"]),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: _assets_ic_qrcode_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === null || _assets_ic_qrcode_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === void 0 ? void 0 : _assets_ic_qrcode_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
            width: 20,
            height: 20,
            alt: "qrcode"
          })
        })
      })
    }), collectBtnHook === null || collectBtnHook === void 0 ? void 0 : collectBtnHook.renderForOperation(), onClick && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      content: t['menu.live.monitor_button'],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        className: (_style_header_module_less__WEBPACK_IMPORTED_MODULE_11___default()["add-btn"]),
        type: "primary",
        icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_assets_ic_plus_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
        onClick: onClick,
        children: t['influencer.monitor.new']
      })
    }), addVideoClick && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      content: t['menu.video.monitor_button'],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        className: (_style_header_module_less__WEBPACK_IMPORTED_MODULE_11___default()["add-btn"]),
        type: "primary",
        icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_assets_ic_plus_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
        onClick: addVideoClick,
        children: t['monitor.video']
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DetailsOperation);

/***/ }),

/***/ 11081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43397);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42586);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59544);





const useCollect = _ref => {
  let {
    collectStatus,
    onCollect,
    onUnCollect
  } = _ref;
  const {
    0: isCollected,
    1: setIsCollected
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(collectStatus === _types_common__WEBPACK_IMPORTED_MODULE_0__/* .CollectStatus.Star */ .c.Star);
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const {
    onShowMemberModal
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .LayoutContext */ .VY);

  const toggleCollect = () => {
    const api = isCollected ? onUnCollect : onCollect;
    setIsLoading(true);
    api().then(res => {
      if ([_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .UNAUTHORIZED_CODE */ .BT].includes(res.data.code)) {
        onShowMemberModal({
          errorMsg: res.data.msg
        });
        return;
      }

      if (res.data.code === _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SUCCESS_CODE */ .Gh) {
        setIsCollected(prev => !prev);
      }
    }).finally(() => {
      setIsLoading(false);
    });
  };

  return {
    isCollected,
    isLoading,
    toggleCollect
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useCollect);

/***/ }),

/***/ 669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65885);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const useCustomField = _ref => {
  let {
    id,
    rawColumns,
    disabledKeys
  } = _ref;
  const defaultColumns = rawColumns.filter(field => !disabledKeys.includes(field.dataIndex)).map(field => {
    return _objectSpread(_objectSpread({}, field), {}, {
      isSelected: true
    });
  });
  const {
    0: customFields,
    1: setCustomFields
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultColumns);
  const [localColumns, setLocalColumns] = (0,ahooks__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(id, {
    defaultValue: []
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if ((localColumns === null || localColumns === void 0 ? void 0 : localColumns.length) > 0) {
      const newList = localColumns.map(l => {
        var _rawColumns$find, _rawColumns$find2;

        return {
          dataIndex: l.dataIndex,
          isSelected: l.isSelected,
          title: (_rawColumns$find = rawColumns.find(i => i.dataIndex === l.dataIndex)) === null || _rawColumns$find === void 0 ? void 0 : _rawColumns$find.title,
          render: (_rawColumns$find2 = rawColumns.find(i => i.dataIndex === l.dataIndex)) === null || _rawColumns$find2 === void 0 ? void 0 : _rawColumns$find2.render
        };
      }).filter(item => item.isSelected === true);
      setCustomFields(newList);
    }
  }, [rawColumns]);
  return {
    defaultColumns,
    customFields,
    setCustomFields
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useCustomField);

/***/ }),

/***/ 86353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42532);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



const useDelayRequest = _ref => {
  let {
    ref
  } = _ref;
  const [inViewport] = (0,ahooks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref);
  const {
    0: isFirst,
    1: setIsFirst
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (inViewport) {
      setTimeout(() => {
        setIsFirst(false);
      });
    }
  }, [inViewport]);
  return {
    isFirst,
    inViewport,
    canRequest: !(isFirst && !inViewport),
    canNoRequest: isFirst && !inViewport
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useDelayRequest);

/***/ }),

/***/ 5120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25617);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1405);



const useLogin = () => {
  const {
    userInfo
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(state => state.global);
  return {
    isLogin: !(0,_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isEmpty */ .xb)(userInfo)
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useLogin);

/***/ }),

/***/ 73717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);

 // 控制是否展示手气展开的 hook

function useNeedFoldView(_ref) {
  let {
    list
  } = _ref;
  const contentWrapRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const {
    0: needFold,
    1: setNeedFold
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const {
    0: showMore,
    1: setShowMore
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);

  const handleGetListWidth = () => {
    var _contentWrapRef$curre;

    const contentHeight = (_contentWrapRef$curre = contentWrapRef.current) === null || _contentWrapRef$curre === void 0 ? void 0 : _contentWrapRef$curre.offsetHeight; // 校验是否需要展示展开收起按钮

    const needShowMoreBtn = contentHeight > 36 + 18;
    setNeedFold(needShowMoreBtn);
    setShowMore(true);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (list) {
      handleGetListWidth();
    }
  }, [list]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const callback = lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(handleGetListWidth, 500);
    window.addEventListener('resize', callback);
    return () => {
      window.removeEventListener('resize', callback);
    }; // eslint-disable-next-line
  }, []);
  return {
    contentWrapRef,
    needFold,
    showMore,
    setShowMore
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useNeedFoldView);

/***/ }),

/***/ 69447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTrackTime; }
/* harmony export */ });
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83126);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);


function useTrackTime(time) {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  if (!time) return ''; // 当前时间

  const presentTime = dayjs__WEBPACK_IMPORTED_MODULE_1___default()().add(1, 'day'); // 传入的时间

  const pastTime = dayjs__WEBPACK_IMPORTED_MODULE_1___default().unix(time);
  const diffDay = presentTime.diff(pastTime, 'day');

  if (diffDay <= 7) {
    return `${diffDay}${t['days.ago']}`;
  }

  return dayjs__WEBPACK_IMPORTED_MODULE_1___default().unix(time).format('YYYY-MM-DD');
}

/***/ }),

/***/ 11868:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/ic-search.352f0a87.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEXr7fPr7PP39/r////4+Pr3+Pr////+/v75+fv4+fv29vfz8/Tq6/Hj4+bi4+bb3N7a2tzOztLHx8y/v8Vke3CnAAAABnRSTlNaWvH+/v7gqsdaAAAAP0lEQVR42j2KSw4AIQjFHg9EnJ863v+usjLpokkLYTMLAnT1hGh6r1k1YL6u0b2kzPG/bgit/XsynVkYxYKyAT6LAbpJhOOdAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 26575:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/ic_header_Link.701073c0.png","height":32,"width":32,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAwUlEQVR42mMAgb9//zKD6H///ukA8aL///8vAdL6YMl795+BJYGCakDBc0DFiUA6Bsg/DVcE1T0VKJiMxI8CmcSwZv0Rnaa21VlATuu3bz/qJ0zZUg01MRWoaCHDwiV7Z0+evjUHKCAPxBPmzN+1EMgPBbKbf/36bckwf9GeFQuX7AuCmgzS0L1w8d48uN0LFu21ACo6BVQUAqTzgfjYvEW7+UFyt24/ZoIrWrBoz8oFi/fOWrB4jwxIbOPmE2DfAQDAk4gbw1yBNQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 71853:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/ic_header_Star.7402bcfc.png","height":28,"width":32,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAQAAACfUMTVAAAAR0lEQVR42iXKsRGAIBAF0T+0CRkNkKgVWo4NGCzunGxwj5sLjdhtsZYak20THQaPn0qN0Iu+mj2ES7y2VUI4ZKVqccrF+i8+lVdWsM74CAMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 18842:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/ic_star.0d20f2c6.png","height":36,"width":40,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAY1BMVEUAAToAATkAADkAADgAADcAADYAADUAADkAAToAATkADTwAAzkAATkAAjkAATkAAjkAATkAATkAATkAATkAATkAAzkAAjkAATkAATkAADkAATkAATkAATkAATkAATkAATkAATnv6FM0AAAAIXRSTlMAAAAAAAICAwcHCQlqbGxydX+Ag4SLjI2Oj5ucoq6/xOdrQMIaAAAAP0lEQVR42gVAhxGAIAx8kygWFIwFC23/KTmYTkoRGPD0XvczMnz+lvnPHnuSfpCk4LgRrZFBwTpnA4GPqlpPbmIoAzVuVgBxAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 7921:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/live-stream.73cbbafa.png","height":40,"width":40,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA2ElEQVR42mP4s/IfMwMQ/FrxTwbIjvyz4l/kr+X/JBmAACTHAGU4/1/zv+n/pv+2/7cA8Zr/LUAxOwYQ+Lb0r9z/1f9bGBieiph4vZrEwPPMhMHqhQhQrO3r0r/SDEDVUf+3/7dmAIKq5LehBfFv1wOZTCAxoFwkw8t5fyL6ct7fCQ5+PY8BCA52/GAOAbJBYiA5hpKkd9nJka//p0a9AWFLIDYHsUFixYlvsxmyY99YpUW9+ZcS+eYnkJZNBWIo+19WzBsrBhAACtoAsRkDFIDYIDEGBgYGAPwNgnLHQF6NAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 32325:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/video2x.b8a3e7e5.png","height":176,"width":176,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAASFBMVEX39/z39/z29vv4+P339/z29vz29vv19fv19frz8/nv7/fv7/bu7/bk5fDe4Oze3+zd3uvc3evb3erZ2+nW2OfU1ubT1eXS1OX3/zyJAAAAA3RSTlPq/v6OOYKAAAAAP0lEQVR42h3LWxZAIAAE0KkZg+QRxf53Sr7vuYCDFA1YGgfKCHM5tzwFMD1ruRPB3GptCz86rr2TJYvqLf79BUX3AfHqdLjLAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 10958:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__VZgeA","datePicker":"index_datePicker__EM_IK","datePickerPopup":"index_datePickerPopup__FLBXs"};

/***/ }),

/***/ 37905:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popConfirm":"index_popConfirm__luyIX","okButton":"index_okButton__Zr3_6","cancelButton":"index_cancelButton___VnjO","collectBtn":"index_collectBtn__C4TFS","collected":"index_collected__r_L20","collet":"index_collet__tzRpC"};

/***/ }),

/***/ 95689:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"width-limit":"index_width-limit__z6JWA","overflow-hidden":"index_overflow-hidden__6PqeD","popup":"index_popup__d_zPK","dropdownContent":"index_dropdownContent__FirBf","title":"index_title__bPOPV","content":"index_content__wog0O","radioGroup":"index_radioGroup__EnGQV","radioItem":"index_radioItem__reggD","actions":"index_actions__Teq__","okButton":"index_okButton__aFy_Q","cancelButton":"index_cancelButton__6q6cE"};

/***/ }),

/***/ 64895:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customTableField":"index_customTableField__diISl","dropList":"index_dropList__Fmfb_","dropItem":"index_dropItem__uoRB0","customFooter":"index_customFooter___7sCp"};

/***/ }),

/***/ 36792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__L0QNv","datePicker":"index_datePicker__V_nA3","datePickerPopup":"index_datePickerPopup__fpqrO"};

/***/ }),

/***/ 77589:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__GMNkT","title":"index_title__WaNUH"};

/***/ }),

/***/ 97916:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__XGlf6","container-divide":"index_container-divide___xxwg"};

/***/ }),

/***/ 6081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__P9fQZ"};

/***/ }),

/***/ 91159:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filterSelectWrap":"index_filterSelectWrap__H9hVB","filterSelectView":"index_filterSelectView__Um0AT","customArea":"index_customArea__WChVc","customInputs":"index_customInputs__Zyzwr","customInput":"index_customInput__CLnla","hyphen":"index_hyphen__BU6Z1","actions":"index_actions__wqSh0","okBtn":"index_okBtn__RGyj4"};

/***/ }),

/***/ 67588:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"introduction":"index_introduction___pJTb","line":"index_line__KBiUM","lineExpand":"index_lineExpand__LTPWi","more":"index_more__9t_Xc"};

/***/ }),

/***/ 77754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkSeo":"index_linkSeo__N4ovM"};

/***/ }),

/***/ 42820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"width-limit":"index_width-limit__D0dic","overflow-hidden":"index_overflow-hidden__kRkmJ","container":"index_container__rv_jf","content":"index_content__VdMwD","contentNav":"index_contentNav__yZqe6","secondContent":"index_secondContent__WQrVE","secondNavItem":"index_secondNavItem__w_i7H","page-nav-tabs":"index_page-nav-tabs__BYQcJ","info-wrapper":"index_info-wrapper__GJSaf","info-wrapper-content":"index_info-wrapper-content__dUnAN","info-wrapper-text":"index_info-wrapper-text__ssYS1","chart-title-text":"index_chart-title-text__q3pHv","info-avatar":"index_info-avatar__8vBZi","action-btn":"index_action-btn__q_WYe"};

/***/ }),

/***/ 58589:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radioGroup":"index_radioGroup__ipt1j"};

/***/ }),

/***/ 43374:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"index_select__Y3qI5"};

/***/ }),

/***/ 41646:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__ut2NJ","item":"index_item__HwRxI","icon":"index_icon__ArJSL","title":"index_title__dm1Ej","count":"index_count__jKK4N","unit":"index_unit__Uwqfm","total":"index_total__oXJdw","total-desc":"index_total-desc__2sFU3","total-num":"index_total-num__D9FXt","header":"index_header__etNXb","header-desc":"index_header-desc__r1_vX","header-num":"index_header-num__vPbdx","average-wrap":"index_average-wrap___kKW5","average-desc":"index_average-desc__tOTFU","average-num":"index_average-num__kESUl","video-item":"index_video-item__srTFp","video-title":"index_video-title__9uWvL","video-content":"index_video-content__PEZFt","video-img":"index_video-img__klmSv","video-info":"index_video-info__7fXnR","video-info-item":"index_video-info-item__QW8ZR","video-footer":"index_video-footer__v7tE2","video-card":"index_video-card__LQjjR","video-card-img":"index_video-card-img__tihjc","video-card-content":"index_video-card-content__b_c13","video-card-content-info-wrap":"index_video-card-content-info-wrap__52HN4","video-card-content-info":"index_video-card-content-info__yBATN","video-card-content-info-item":"index_video-card-content-info-item__hAA31","video-card-content-num":"index_video-card-content-num__g88ZS","video-card-author":"index_video-card-author__pnEhx","video-card-author-title":"index_video-card-author-title__QDsUF","video-card-author-influencer":"index_video-card-author-influencer__2dG63","video-card-author-avatar":"index_video-card-author-avatar__sdeFG","video-card-author-name":"index_video-card-author-name__6CHi2","video-card-author-time":"index_video-card-author-time__QjA_d","video-card-desc":"index_video-card-desc__18b8G","video-card-footer":"index_video-card-footer__Czw0g","video-card-btn-wrap":"index_video-card-btn-wrap__fwQlv","video-card-btn":"index_video-card-btn__j5OKx","averages":"index_averages__zhj0q","product-video-Montmorillonite":"index_product-video-Montmorillonite__wBudu","video-card-content-product-wrap":"index_video-card-content-product-wrap__oXqH8","video-card-content-product-info":"index_video-card-content-product-info__uWROr","video-card-content-product-img-wrap":"index_video-card-content-product-img-wrap__RZdv1","video-card-content-product-img":"index_video-card-content-product-img__6nN8o","video-card-content-product-title":"index_video-card-content-product-title__Aricw","video-card-content-product-item":"index_video-card-content-product-item__2KMft","video-card-content-back":"index_video-card-content-back___zEhD"};

/***/ }),

/***/ 48525:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select-types":"index_select-types__kAS_2","typeSelected":"index_typeSelected__jXmZg"};

/***/ }),

/***/ 28394:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"video-modal":"index_video-modal__HU0Jf","download-btn":"index_download-btn__g_07d"};

/***/ }),

/***/ 81976:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgWrap":"index_imgWrap__kQA6o","product-video-Montmorillonite":"index_product-video-Montmorillonite__zeL0c"};

/***/ }),

/***/ 22497:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"edit-btn":"header_edit-btn__8vqmK","action-btn":"header_action-btn__d8VYI","select":"header_select__Oyi1d","add-btn":"header_add-btn__lh4xu"};

/***/ })

}]);